import { Prop } from '../interfaces/prop.interface';

export const propsOriginalJson: any[] = [
    {
        "id": "647ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "1: SALE 2:RENT 3:BOTH",
        "address": " Torras Y Bages  51   ",
        "postalCode": "08030",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "242.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.68",
        "surfaceTotal": "242.68",
        "timeAvailableFrom": "9/13/22 13:22",
        "name": "Nombre del Local",
        "visible": "TRUE",
        "features": "Terrace, Parking space included, Storeroom, Good condition",
        "highLights": "Incluidas 90 plazas de aparcamiento en el precio, Edificio exclusivo en parque empresarial, Rápido acceso a A-1, M-40, M-50 y R-2",
        "descshort": "Descripción corta",
        "descLong": "Descripción larga",
        "comment": "¡En oferta!"
    },
    {
        "id": "a47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza Puerta De Ávila  18   ",
        "postalCode": "37700",
        "city": "1137046",
        "municipio": "Bejar",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "146.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "219.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.25",
        "surfaceTotal": "365.62",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "a87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1026.67",
        "askingPriceSale": "114846.67",
        "address": "Calle Vera Cruz  2   ",
        "postalCode": "23680",
        "city": "1123002",
        "municipio": "Alcala La Real",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.45",
        "surfaceTotal": "164.45",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "aa7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Corredera De San Fernando  28   ",
        "postalCode": "23400",
        "city": "1123092",
        "municipio": "Ubeda",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "495.78",
        "surfaceMezzanine": "0.00",
        "surfacepb": "837.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "985.89",
        "surfaceTotal": "1332.94",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "ac7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Onze de Setembre  36   ",
        "postalCode": "17230",
        "city": "1117118",
        "municipio": "Palamos",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "142.38",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "129.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "279.32",
        "surfaceTotal": "443.84",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "b87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "5866.00",
        "askingPriceSale": "1026550.00",
        "address": "Calle Herradores  47   ",
        "postalCode": "38201",
        "city": "1138023",
        "municipio": "La Laguna",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "356.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "161.47",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "436.84",
        "surfaceTotal": "517.57",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "ba7ce90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "466.20",
        "askingPriceSale": "62160.00",
        "address": "Calle Real  2   ",
        "city": "1121013",
        "municipio": "Bollullos Del Condado",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "be7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1862.96",
        "askingPriceSale": "293822.89",
        "address": "Calle Ramiranes  1   ",
        "postalCode": "36400",
        "city": "1136039",
        "municipio": "Porriño",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "122.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.10",
        "surfaceTotal": "357.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "c47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3160.50",
        "askingPriceSale": "526750.00",
        "address": "Calle Travessera De Las Corts  3   ",
        "postalCode": "08028",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "165.00",
        "surfaceTotal": "165.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "c67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1708.00",
        "askingPriceSale": "239120.00",
        "address": "Calle Antón  23   ",
        "postalCode": "30004",
        "city": "1130030",
        "municipio": "Murcia",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.13",
        "surfaceBasement1": "144.13",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "144.13",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "216.20",
        "surfaceTotal": "288.26",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "c87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Real  34   ",
        "postalCode": "10210",
        "city": "1110113",
        "municipio": "Madroñera",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "114.81",
        "surfaceMezzanine": "0.00",
        "surfacepb": "139.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.44",
        "surfaceTotal": "253.81",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "ca7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1752.80",
        "askingPriceSale": "262920.00",
        "address": "Calle Morerillas  1   ",
        "postalCode": "41700",
        "city": "1141038",
        "municipio": "Dos Hermanas",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "300.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "300.00",
        "surfaceTotal": "300.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "d27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1578.50",
        "askingPriceSale": "238210.00",
        "address": "Calle Capitán Mendizábal  8   ",
        "postalCode": "48980",
        "city": "1148082",
        "municipio": "Santurce/Santurtzi",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "30.88",
        "surfaceMezzanine": "0.00",
        "surfacepb": "211.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.54",
        "surfaceTotal": "242.16",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "d47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza Villa  2   ",
        "city": "1108169",
        "municipio": "El Prat De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "235.03",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.03",
        "surfaceTotal": "235.03",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "d87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2114.00",
        "askingPriceSale": "338240.00",
        "address": "Avenida Sancho Sancho El Sabio  33   ",
        "postalCode": "20010",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.00",
        "surfaceTotal": "151.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "de7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1137.99",
        "askingPriceSale": "170698.50",
        "address": " Paraguay  2   ",
        "postalCode": "01012",
        "city": "1101059",
        "municipio": "Vitoria/Gasteiz",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.57",
        "surfaceTotal": "162.57",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "e27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2822.40",
        "askingPriceSale": "441000.00",
        "address": "Calle Baleares     ",
        "postalCode": "28937",
        "city": "1128092",
        "municipio": "Mostoles",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.00",
        "surfaceTotal": "255.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "e47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2522.80",
        "askingPriceSale": "385840.00",
        "address": "Calle Gava  62   ",
        "postalCode": "08014",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.63",
        "surfaceTotal": "198.63",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "e67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Travesía Bayona  1   ",
        "postalCode": "31011",
        "city": "1131201",
        "municipio": "Pamplona/Iruña",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "245.16",
        "surfaceTotal": "245.16",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "ea7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1232.00",
        "askingPriceSale": "231000.00",
        "address": "Avenida Constitución  19   ",
        "postalCode": "33208",
        "city": "1133024",
        "municipio": "Gijon",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.50",
        "surfaceTotal": "143.50",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "ec7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "33600.00",
        "askingPriceSale": "9240000.00",
        "address": " Goya  77   ",
        "postalCode": "28001",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "173.81",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.49",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.63",
        "surfaceTotal": "359.30",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "f07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1178.10",
        "askingPriceSale": "160650.00",
        "address": " Pedro Aleixandre  25   ",
        "postalCode": "46006",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.52",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.52",
        "surfaceTotal": "134.52",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "f27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2058.00",
        "askingPriceSale": "323400.00",
        "address": "Avenida Madrid  191   ",
        "postalCode": "50017",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "175.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.50",
        "surfaceTotal": "373.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "f67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2595.60",
        "askingPriceSale": "389340.00",
        "address": "Calle Tomás Ortuño  83   ",
        "postalCode": "03500",
        "city": "1103031",
        "municipio": "Benidorm",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "219.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.34",
        "surfaceTotal": "219.34",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "fa7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "address": "Calle O'Donnell  23   ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "Sí",
        "surfacebr": "221.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "376.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "442.30",
        "surfaceTotal": "597.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "fe7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2166.15",
        "askingPriceSale": "346584.00",
        "address": "Calle Ecuador  2   ",
        "postalCode": "45004",
        "city": "1145168",
        "municipio": "Toledo",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "190.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.18",
        "surfaceTotal": "381.82",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "067de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Mármol  10   ",
        "postalCode": "28850",
        "city": "1128148",
        "municipio": "Torrejon De Ardoz",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.41",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.41",
        "surfaceTotal": "157.41",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "087de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1766.24",
        "askingPriceSale": "203057.92",
        "address": "Calle Jabonería  53   ",
        "postalCode": "28921",
        "city": "1128007",
        "municipio": "Alcorcon",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "106.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "60.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "166.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "0e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Calle San Pedro De Mezonzo  3   ",
        "postalCode": "15705",
        "city": "1115078",
        "municipio": "Santiago De Compostela",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "217.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "273.10",
        "surfaceTotal": "425.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "107de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Calle Costa Rica  9   ",
        "postalCode": "28005",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "139.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "310.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "351.90",
        "surfaceTotal": "449.48",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "127de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1359.75",
        "askingPriceSale": "199430.00",
        "address": " Pinto     ",
        "postalCode": "28980",
        "city": "1128106",
        "municipio": "Parla",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "266.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.00",
        "surfaceTotal": "266.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "1a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1217.16",
        "askingPriceSale": "210974.40",
        "address": "Plaza Mercadal C/V Mayor     ",
        "postalCode": "25600",
        "city": "1125040",
        "municipio": "Balaguer",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "277.76",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "182.76",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "355.59",
        "surfaceTotal": "641.40",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "1e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Mallorca  547   ",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "44.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "44.00",
        "surfaceTotal": "44.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "207de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2401.00",
        "askingPriceSale": "351467.04",
        "address": "Calle Autonomía  20   ",
        "postalCode": "48012",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.25",
        "surfaceTotal": "161.25",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "247de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "address": "Avenida Constitución  15   ",
        "postalCode": "18001",
        "city": "1118087",
        "municipio": "Granada",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "155.31",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.90",
        "surfaceTotal": "310.62",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "287de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1079.40",
        "askingPriceSale": "161910.00",
        "address": "Calle Agua  2   ",
        "postalCode": "14900",
        "city": "1114038",
        "municipio": "Lucena",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "324.35",
        "surfaceTotal": "324.35",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "2a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Calle Borne  36   ",
        "postalCode": "08240",
        "city": "1108113",
        "municipio": "Manresa",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "148.63",
        "surfaceMezzanine": "0.00",
        "surfacepb": "204.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "249.29",
        "surfaceTotal": "353.33",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "307de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1400.00",
        "askingPriceSale": "210000.00",
        "address": "Calle San Francisco  4   ",
        "postalCode": "30510",
        "city": "1130043",
        "municipio": "Yecla",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "208.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "450.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "512.40",
        "surfaceTotal": "658.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "3a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Pons I Ariola,  10   ",
        "postalCode": "25240",
        "city": "1125122",
        "municipio": "Linyola",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "105.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "105.95",
        "surfaceTotal": "105.95",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "3c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Carnicerias  2   ",
        "postalCode": "31593",
        "city": "1131105",
        "municipio": "Fitero",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "3e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " L'Horta  11   ",
        "postalCode": "25126",
        "city": "1125021",
        "municipio": "Almenar",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.18",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.18",
        "surfaceTotal": "153.18",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "427de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "13300.00",
        "askingPriceSale": "2660000.00",
        "address": "Calle Santa Mónica  6   ",
        "postalCode": "08002",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Equipamiento",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "410.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "410.00",
        "surfaceTotal": "410.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "447de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3957.80",
        "askingPriceSale": "791560.00",
        "address": "Vía Augusta  81   ",
        "postalCode": "08006",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "75.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.42",
        "surfaceTotal": "251.16",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "467de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "4900.00",
        "askingPriceSale": "931000.00",
        "address": "Calle Marqués De Sentmenat  44   ",
        "postalCode": "08014",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "389.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "389.24",
        "surfaceTotal": "389.24",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "4a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1114.40",
        "askingPriceSale": "174125.00",
        "address": "Avenida Libertad  26   ",
        "postalCode": "03690",
        "city": "1103122",
        "municipio": "San Vicente Raspeig",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "49.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "111.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "267.02",
        "surfaceTotal": "357.02",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "547de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2655.80",
        "askingPriceSale": "478044.00",
        "address": "Avenida Peña Prieta  57   ",
        "district": "2807913",
        "postalCode": "28038",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "88.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "207.40",
        "surfaceTotal": "269.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "667de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3186.40",
        "askingPriceSale": "605416.00",
        "address": "Calle Emperador Carlos V  1   ",
        "postalCode": "50009",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "727de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4591.10",
        "askingPriceSale": "819840.00",
        "address": "Avenida Zaragoza  11   ",
        "postalCode": "31003",
        "city": "1131201",
        "municipio": "Pamplona/Iruña",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "234.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.24",
        "surfaceTotal": "234.24",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "767de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Estación  58   ",
        "postalCode": "09200",
        "city": "1109219",
        "municipio": "Miranda De Ebro",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "295.54",
        "surfaceMezzanine": "0.00",
        "surfacepb": "295.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "384.20",
        "surfaceTotal": "591.08",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "7a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "891.80",
        "askingPriceSale": "152880.00",
        "address": " Rioja  8   ",
        "postalCode": "28915",
        "city": "1128074",
        "municipio": "Leganes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.04",
        "surfaceTotal": "84.04",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "807de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2028.60",
        "askingPriceSale": "251160.00",
        "address": "Camino De Vinateros  63   ",
        "postalCode": "28030",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "No",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "183.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "183.15",
        "surfaceTotal": "183.15",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "827de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": " Aribau  249   ",
        "postalCode": "08021",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.50",
        "surfaceTotal": "152.50",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "927de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Caldereros  6   ",
        "postalCode": "05200",
        "city": "1105016",
        "municipio": "Arevalo",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "119.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.50",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.10",
        "surfaceTotal": "358.50",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "967de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1134.00",
        "askingPriceSale": "157500.00",
        "address": " Julio Antonio  1   ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "87.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.10",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "9c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Calle Arenal  19   ",
        "district": "2807901",
        "postalCode": "28013",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "148.85",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "210.59",
        "surfaceTotal": "314.78",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "9e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Del Padró  12   ",
        "postalCode": "08291",
        "city": "1108180",
        "municipio": "Ripollet",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "132.60",
        "surfaceMezzanine": "0.00",
        "surfacepb": "288.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "198.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "426.78",
        "surfaceTotal": "618.60",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Caspe  70   ",
        "postalCode": "08010",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "297.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "297.94",
        "surfaceTotal": "297.94",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1411.20",
        "askingPriceSale": "241920.00",
        "address": " Batllori  7   ",
        "postalCode": "08031",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "62.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.85",
        "surfaceTotal": "192.05",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "aa7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1694.00",
        "askingPriceSale": "321860.00",
        "address": "Vía Augusta  264   ",
        "postalCode": "08017",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "48.59",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.43",
        "surfaceTotal": "145.44",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ac7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Balmes  423   ",
        "postalCode": "08022",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.80",
        "surfaceTotal": "155.80",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ae7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2492.00",
        "askingPriceSale": "448560.00",
        "address": "Paseo Manuel Girona  12   ",
        "postalCode": "08034",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "129.42",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.15",
        "surfaceTotal": "257.74",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1680.07",
        "askingPriceSale": "303598.39",
        "address": " Santa Susana  27   ",
        "postalCode": "28033",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "97.38",
        "surfaceMezzanine": "0.00",
        "surfacepb": "75.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.83",
        "surfaceTotal": "173.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "4253.76",
        "askingPriceSale": "797580.00",
        "address": "Avenida Doctor Areilza  26   ",
        "postalCode": "48011",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.90",
        "surfaceTotal": "189.90",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ba7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1813.00",
        "askingPriceSale": "310800.00",
        "address": " Vitoria  141   ",
        "postalCode": "09007",
        "city": "1109059",
        "municipio": "Burgos",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "bc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2387.28",
        "askingPriceSale": "341040.00",
        "address": "Avenida Rafael Puig  s/n   ",
        "postalCode": "38670",
        "city": "1138660",
        "municipio": "Playa De Las Americas",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "56.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.80",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "be7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Aire  21   ",
        "city": "1130016",
        "municipio": "Cartagena",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "229.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.85",
        "surfaceTotal": "229.70",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1345.68",
        "askingPriceSale": "201852.00",
        "address": " Tomas Morales  83   ",
        "postalCode": "35004",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.20",
        "surfaceTotal": "160.20",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ca7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1217.41",
        "askingPriceSale": "197581.60",
        "address": "Calle Cervantes  14   ",
        "postalCode": "28904",
        "city": "1128065",
        "municipio": "Getafe",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.00",
        "surfaceTotal": "146.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "cc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1916.88",
        "askingPriceSale": "319480.00",
        "address": " Pozo  1   ",
        "postalCode": "24003",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "74.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "92.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.81",
        "surfaceTotal": "166.76",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ce7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida República Argentina  1   ",
        "city": "1146145",
        "municipio": "Jativa/Xativa",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.00",
        "surfaceTotal": "193.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Prat De La Riva  29   ",
        "postalCode": "25008",
        "city": "1125120",
        "municipio": "Lleida",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.25",
        "surfaceTotal": "113.25",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "4100.60",
        "askingPriceSale": "593880.00",
        "address": "Calle Can Mora  7   ",
        "postalCode": "08190",
        "city": "1108205",
        "municipio": "Sant Cugat Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.77",
        "surfaceTotal": "189.77",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6832.00",
        "askingPriceSale": "1537200.00",
        "address": " Lagasca  13   ",
        "postalCode": "28001",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.28",
        "surfaceTotal": "120.28",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "7938.00",
        "askingPriceSale": "1481760.00",
        "address": "Plaza Cascorro  23   ",
        "postalCode": "28005",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "188.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "450.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "453.40",
        "surfaceTotal": "810.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "26180.70",
        "askingPriceSale": "7230860.00",
        "address": " Carretas  14   ",
        "district": "2807902",
        "postalCode": "28012",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "No",
        "surfacebr": "166.48",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.34",
        "surfaceTotal": "308.52",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "da7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5559.68",
        "askingPriceSale": "1077188.00",
        "address": " Cea Bermudez  25-27   ",
        "district": "2807907",
        "postalCode": "28003",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "248.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.20",
        "surfaceTotal": "248.20",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "dc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceSale": "173040.00",
        "address": " Miguel Angel  3   ",
        "postalCode": "28010",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "83.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "57.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "168.40",
        "surfaceTotal": "255.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ea7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Plaza Emilio Díaz De Revenga  1   ",
        "postalCode": "30008",
        "city": "1130030",
        "municipio": "Murcia",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "433.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "35.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "451.19",
        "surfaceTotal": "468.69",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1156.40",
        "askingPriceSale": "165200.00",
        "address": "Paseo Olmos  18   ",
        "postalCode": "20016",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "110.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "85.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.00",
        "surfaceTotal": "195.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "2177.00",
        "askingPriceSale": "326550.00",
        "address": " Usandizaga  29   ",
        "postalCode": "20002",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "75.00",
        "surfacepb": "118.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "75.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.50",
        "surfaceTotal": "193.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "027ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "640.50",
        "askingPriceSale": "85400.00",
        "address": "Avenida Italia  18   ",
        "postalCode": "35100",
        "city": "1135019",
        "municipio": "San Bartolome De Tirajana",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "117.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.20",
        "surfaceTotal": "117.20",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "047ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "1171.10",
        "askingPriceSale": "150500.00",
        "address": "Plaza Bayarri  6   ",
        "postalCode": "12540",
        "city": "1112135",
        "municipio": "Villarreal/Vila-Real",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "301.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "357.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "479.60",
        "surfaceTotal": "658.10",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "067ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2598.96",
        "askingPriceSale": "498134.00",
        "address": " Gran Via  46- 48   ",
        "postalCode": "50005",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.70",
        "surfaceTotal": "154.70",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "0a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1190.00",
        "askingPriceSale": "142800.00",
        "address": " Miraflores  105   ",
        "postalCode": "08905",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "10.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.00",
        "surfaceTotal": "10.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "0e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "873.60",
        "askingPriceSale": "123760.00",
        "address": " Doctor Loureiro Crespo  20   ",
        "postalCode": "36004",
        "city": "1136038",
        "municipio": "Pontevedra",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "167ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Carretera Cartagena-Alicante     ",
        "postalCode": "30730",
        "city": "1130035",
        "municipio": "San Javier",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "131.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.14",
        "surfaceTotal": "295.40",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "1c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Francesc Layret  13   ",
        "postalCode": "08208",
        "city": "1108187",
        "municipio": "Sabadell",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "108.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.00",
        "surfaceTotal": "108.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "1e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "690.90",
        "askingPriceSale": "105280.00",
        "address": "Paseo General Dávila     ",
        "postalCode": "39007",
        "city": "1139075",
        "municipio": "Santander",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.21",
        "surfaceTotal": "144.21",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "207ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1335.60",
        "askingPriceSale": "222600.00",
        "address": "Calle Ervedelo  37   ",
        "city": "1132054",
        "municipio": "Ourense",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.14",
        "surfaceTotal": "164.14",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "247ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2004.80",
        "askingPriceSale": "350840.00",
        "address": "Calle Gran Via Carles III  94   ",
        "postalCode": "08028",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "No",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.95",
        "surfaceTotal": "170.95",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "267ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1209.60",
        "askingPriceSale": "188160.00",
        "address": "Avenida Ana De Viya  54   ",
        "postalCode": "11009",
        "city": "1111012",
        "municipio": "Cadiz",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.10",
        "surfaceTotal": "96.10",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "2a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza De Fornells  23   ",
        "postalCode": "08033",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "109.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.00",
        "surfaceTotal": "109.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "2c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": " Marques De Paradas  26   ",
        "postalCode": "41001",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "188.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.91",
        "surfaceTotal": "188.91",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "2e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Avenida De Los Playeros     ",
        "postalCode": "38650",
        "city": "1138650",
        "municipio": "Playa De Los Cristianos",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "163.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.27",
        "surfaceTotal": "284.54",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "307ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "966.00",
        "askingPriceSale": "144900.00",
        "address": "Paseo Estacion  42401   ",
        "postalCode": "37003",
        "city": "1137274",
        "municipio": "Salamanca",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "347ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1389.88",
        "askingPriceSale": "203849.80",
        "address": " Ezequiel Solana  97   ",
        "district": "2807920",
        "postalCode": "28017",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.37",
        "surfaceTotal": "132.37",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "367ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1354.50",
        "askingPriceSale": "210700.00",
        "address": "Avenida Sancho El Fuerte  24   ",
        "postalCode": "31007",
        "city": "1131201",
        "municipio": "Pamplona/Iruña",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.50",
        "surfaceTotal": "107.50",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "387ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2158.52",
        "askingPriceSale": "325604.44",
        "address": "Urbanización San Eugenio     ",
        "postalCode": "38660",
        "city": "1138660",
        "municipio": "Playa De Las Americas",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "54.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "215.54",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.97",
        "surfaceTotal": "269.54",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "3a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1965.60",
        "askingPriceSale": "294840.00",
        "address": " Limones  SN   ",
        "postalCode": "35570",
        "city": "1135034",
        "municipio": "Yaiza",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "131.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.00",
        "surfaceTotal": "131.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "3c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1041.60",
        "askingPriceSale": "156240.00",
        "address": " Eric Lionel Fox  3   ",
        "postalCode": "38005",
        "city": "1138038",
        "municipio": "Santa Cruz De Tenerife",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "70.15",
        "surfaceMezzanine": "0.00",
        "surfacepb": "109.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.05",
        "surfaceTotal": "179.15",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "427ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1951.72",
        "askingPriceSale": "305487.00",
        "address": " Doctor J.J. Domine  14   ",
        "postalCode": "46011",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "242.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.45",
        "surfaceTotal": "242.45",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "447ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2615.34",
        "askingPriceSale": "496244.00",
        "address": " Rodriguez San Pedro  8   ",
        "district": "2807907",
        "postalCode": "28015",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "84.37",
        "surfaceMezzanine": "0.00",
        "surfacepb": "69.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "28.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.11",
        "surfaceTotal": "182.54",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "467ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1035.22",
        "askingPriceSale": "198416.40",
        "address": "Avenida Juan De Austria,  32   ",
        "postalCode": "28804",
        "city": "1128005",
        "municipio": "Alcala De Henares",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "179.71",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.57",
        "surfaceTotal": "325.37",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "487ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2033.29",
        "askingPriceSale": "346493.05",
        "address": "Carretera De Canillas  21   ",
        "district": "2807916",
        "postalCode": "28043",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "527ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "4306.54",
        "askingPriceSale": "974638.00",
        "address": " Doctor Fleming  16   ",
        "district": "2807905",
        "postalCode": "28036",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "207.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.21",
        "surfaceTotal": "344.46",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "547ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1558.94",
        "askingPriceSale": "268413.60",
        "address": " Numancia  6   ",
        "district": "2807906",
        "postalCode": "28039",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.48",
        "surfaceTotal": "147.48",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "567ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2114.91",
        "askingPriceSale": "344652.00",
        "address": "Calle Claret  10   ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "36.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.14",
        "surfaceTotal": "112.34",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "587ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2768.50",
        "askingPriceSale": "569520.00",
        "address": "Calle Mejía Lequerica  16   ",
        "district": "2807901",
        "postalCode": "28004",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "5a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Retuerto  60   ",
        "postalCode": "48903",
        "city": "1148013",
        "municipio": "Barakaldo",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.73",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.73",
        "surfaceTotal": "171.73",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "5c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": " Sant Miquel  51   ",
        "postalCode": "07002",
        "city": "1107040",
        "municipio": "Palma De Mallorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "105.51",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "80.26",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "216.20",
        "surfaceTotal": "330.19",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "5e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1511.84",
        "askingPriceSale": "288026.29",
        "address": " Valdelasierra  10   ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.30",
        "surfaceTotal": "126.30",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "627ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2833.60",
        "askingPriceSale": "453376.00",
        "address": "Plaza De La Inmaculada  7   ",
        "postalCode": "24001",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "53.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "211.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.82",
        "surfaceTotal": "265.48",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "6a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Vista Alegre  5   ",
        "postalCode": "39001",
        "city": "1139075",
        "municipio": "Santander",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "6e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1394.40",
        "askingPriceSale": "209160.00",
        "address": " Oceano Atlantico  3   ",
        "postalCode": "28820",
        "city": "1128049",
        "municipio": "Coslada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "165.74",
        "surfaceTotal": "165.74",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "707ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1969.80",
        "askingPriceSale": "309540.00",
        "address": " Amador D. Rios  48-50   ",
        "postalCode": "41003",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "184.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "184.33",
        "surfaceTotal": "184.33",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "767ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "994.22",
        "askingPriceSale": "149133.60",
        "address": " Txomin Garat,  7   ",
        "postalCode": "48004",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.36",
        "surfaceTotal": "118.36",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "807ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2772.00",
        "askingPriceSale": "400400.00",
        "address": "Calle De De La Cala     ",
        "postalCode": "29649",
        "city": "1129070",
        "municipio": "Mijas",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.00",
        "surfaceBasement1": "178.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "178.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "267.00",
        "surfaceTotal": "356.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "847ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1302.00",
        "askingPriceSale": "182280.00",
        "address": "Calle Sor Valentina Mirón  82   ",
        "postalCode": "10600",
        "city": "1110148",
        "municipio": "Plasencia",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.05",
        "surfaceTotal": "186.05",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "887ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "699.30",
        "askingPriceSale": "87723.48",
        "address": " Antonio Huertas  149   ",
        "city": "1113082",
        "municipio": "Tomelloso",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.00",
        "surfaceTotal": "111.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ea7ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceSale": "288148.00",
        "address": "Rua De Galicia  10   ",
        "city": "1115057",
        "municipio": "Noia",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "130.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "235.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.50",
        "surfaceTotal": "495.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "007fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "1282.15",
        "askingPriceSale": "221060.00",
        "address": "Calle Ramiro  I   ",
        "postalCode": "33012",
        "city": "1133044",
        "municipio": "Oviedo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "129.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.78",
        "surfaceTotal": "255.48",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "2280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "705.60",
        "askingPriceSale": "114660.00",
        "address": "Avenida De Andalucia  31   ",
        "postalCode": "29570",
        "city": "1129038",
        "municipio": "Cartama",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.29",
        "surfaceTotal": "124.29",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4c81e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "797.89",
        "askingPriceSale": "99736.00",
        "address": "Plaza DeEspaña  19   ",
        "city": "1116067",
        "municipio": "Castejon",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "142.48",
        "surfaceTotal": "142.48",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8c82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "593.60",
        "askingPriceSale": "74200.00",
        "address": " La Libertad  24   ",
        "city": "1133980",
        "municipio": "Pola De Laviana",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "103.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "51.50",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Mallorca  547   ",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "98.74",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "49.37",
        "surfaceTotal": "98.74",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "a47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Valencia  617   ",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.00",
        "surfaceTotal": "202.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ee7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1436.40",
        "askingPriceSale": "191520.00",
        "address": " Michelena  26   ",
        "postalCode": "36002",
        "city": "1136038",
        "municipio": "Pontevedra",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "179.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "360.00",
        "surfaceBasement1": "358.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "358.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "592.70",
        "surfaceTotal": "897.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ae7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza goiko portala  4   ",
        "postalCode": "48270",
        "city": "1148060",
        "municipio": "Markina-Xemein",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "73.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "73.00",
        "surfaceTotal": "73.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "b07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza samuel picazo  3   ",
        "postalCode": "01110",
        "city": "1101017",
        "municipio": "Campezo",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "90.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "b47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza españa  27   ",
        "postalCode": "06370",
        "city": "1106022",
        "municipio": "Burguillos Del Cerro",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "bc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza emilio castelar  5   ",
        "postalCode": "46100",
        "city": "1146078",
        "municipio": "Burjassot",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.00",
        "surfaceTotal": "215.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "c27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Avenida Alameda  8   ",
        "postalCode": "03803",
        "city": "1103009",
        "municipio": "Alcoy/Alcoi",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "175.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "3.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.00",
        "surfaceTotal": "386.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "cc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Gran de la Sagrera  158   ",
        "postalCode": "08027",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "119.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.70",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "d07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle borbolla  13   ",
        "postalCode": "41004",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "67.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.10",
        "surfaceTotal": "267.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "da7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " santa ana  21   ",
        "postalCode": "20540",
        "city": "1120034",
        "municipio": "Eskoriatza",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "68.00",
        "surfaceTotal": "68.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "dc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle iturriza     ",
        "postalCode": "48240",
        "city": "1148019",
        "municipio": "Berriz",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.00",
        "surfaceTotal": "194.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "ee7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida pino montano  22   ",
        "postalCode": "41008",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.00",
        "surfaceTotal": "250.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "fc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle begoñalde  3   ",
        "postalCode": "48007",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.00",
        "surfaceTotal": "166.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "007de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "ALQUILER",
        "address": "Avenida Burjasot  33   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "154.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "027de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Paseo generalitat  18   ",
        "postalCode": "08500",
        "city": "1108298",
        "municipio": "Vic",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "93.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "93.00",
        "surfaceTotal": "93.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "047de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida república argentina  41   ",
        "postalCode": "46700",
        "city": "1146131",
        "municipio": "Gandia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "187de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida Holanda  10   ",
        "postalCode": "03540",
        "city": "1103014",
        "municipio": "Alicante/Alacant",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.00",
        "surfaceTotal": "153.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "327de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " real  67   ",
        "postalCode": "02110",
        "city": "1102035",
        "municipio": "La Gineta",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.00",
        "surfaceTotal": "124.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "367de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle rodrigo rebolledo  36   ",
        "postalCode": "50002",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "123.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.90",
        "surfaceTotal": "263.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "507de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle vázquez de parga  5   ",
        "postalCode": "15100",
        "city": "1115019",
        "municipio": "Carballo",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.00",
        "surfaceTotal": "250.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "527de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Calle Villaviciosa  36   ",
        "district": "2807910",
        "postalCode": "28024",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "91.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "91.00",
        "surfaceTotal": "91.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "567de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle peñón  5   ",
        "postalCode": "28923",
        "city": "1128007",
        "municipio": "Alcorcon",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "587de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " san adrian  133   ",
        "postalCode": "08030",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "5a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle j. rubio i orts o rosello 67  31   ",
        "postalCode": "08830",
        "city": "1108200",
        "municipio": "Sant Boi De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "5c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Singladura  7   ",
        "postalCode": "07610",
        "city": "1107040",
        "municipio": "Palma De Mallorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "5e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle mar  29   ",
        "postalCode": "07680",
        "city": "1107033",
        "municipio": "Manacor",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "136.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "258.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "687de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida juan carlos i  1   ",
        "postalCode": "30840",
        "city": "1130008",
        "municipio": "Alhama De Murcia",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "134.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "108.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "108.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "134.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.20",
        "surfaceTotal": "353.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "6a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " juan xxiii  10   ",
        "postalCode": "07470",
        "city": "1107042",
        "municipio": "Pollença",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "707de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza trinidad  5   ",
        "postalCode": "08033",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "215.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "39.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.50",
        "surfaceTotal": "254.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "7c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Mosen Jacinto Verdaguer  136   ",
        "postalCode": "08923",
        "city": "1108245",
        "municipio": "Santa Coloma De Gramanet",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "21.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "89.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "95.30",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "7e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " navarra  16   ",
        "postalCode": "41015",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "867de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " callao  42   ",
        "postalCode": "28945",
        "city": "1128058",
        "municipio": "Fuenlabrada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "142.00",
        "surfaceTotal": "142.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "907de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " San Jerónimo  20   ",
        "postalCode": "11640",
        "city": "1111010",
        "municipio": "Bornos",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.00",
        "surfaceTotal": "132.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "947de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " alcalde manuel alberola  10   ",
        "postalCode": "03660",
        "city": "1103093",
        "municipio": "Novelda",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.00",
        "surfaceTotal": "126.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida de la Cañada  27   ",
        "postalCode": "11203",
        "city": "1111004",
        "municipio": "Algeciras",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "128.00",
        "surfaceTotal": "128.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida ernesto che guevara  5   ",
        "postalCode": "15172",
        "city": "1115058",
        "municipio": "Oleiros",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " hirigoien  1   ",
        "postalCode": "20210",
        "city": "1120049",
        "municipio": "Lazkao",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.00",
        "surfaceTotal": "144.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ec7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " parque municipal  4   ",
        "postalCode": "15680",
        "city": "1115059",
        "municipio": "Ordes",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "49.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "241.50",
        "surfaceTotal": "266.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "fe7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida primero de junio  46   ",
        "postalCode": "34200",
        "city": "1134023",
        "municipio": "Venta De Baños",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.00",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "007ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Paseo Riera  124   ",
        "postalCode": "08329",
        "city": "1108281",
        "municipio": "Teia",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "0c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " brasil  20   ",
        "postalCode": "33213",
        "city": "1133024",
        "municipio": "Gijon",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "114.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.00",
        "surfaceTotal": "114.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "127ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " mayor  20   ",
        "postalCode": "31600",
        "city": "1131060",
        "municipio": "Burlada",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "58.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.00",
        "surfaceTotal": "181.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "147ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " castelar  7   ",
        "postalCode": "30366",
        "city": "1130016",
        "municipio": "Cartagena",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "1a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " el piñal  15   ",
        "postalCode": "39313",
        "city": "1139054",
        "municipio": "Polanco",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.00",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "287ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Travesía de les Corts  371   ",
        "postalCode": "08029",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "4a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Ronda industria  49   ",
        "postalCode": "08210",
        "city": "1108252",
        "municipio": "Barbera Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "4c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "address": "Avenida coruña  9   ",
        "postalCode": "15189",
        "city": "1101021",
        "municipio": "El Burgo",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "4e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Calle juan dominguez perez  19   ",
        "postalCode": "35008",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "507ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida hytasa  36   ",
        "postalCode": "41006",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "667ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Paseo del espolon  24   ",
        "postalCode": "42001",
        "city": "1142173",
        "municipio": "Soria",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "687ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "address": "Calle Molini  s/n   ",
        "postalCode": "41012",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "6c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida maria fortuny  40   ",
        "postalCode": "43201",
        "city": "1143123",
        "municipio": "Reus",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "135.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "213.50",
        "surfaceTotal": "281.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "747ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle de tremp  31   ",
        "postalCode": "08032",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "101.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "101.00",
        "surfaceTotal": "101.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "787ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " el hayedo  1   ",
        "postalCode": "24007",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "270.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "270.00",
        "surfaceTotal": "270.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "827ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida La Torrecilla  3   ",
        "postalCode": "14013",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " renteria  1   ",
        "postalCode": "20301",
        "city": "1120045",
        "municipio": "Irun",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "49.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "14.70",
        "surfaceTotal": "49.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "de82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " clunia  6   ",
        "postalCode": "09005",
        "city": "1109059",
        "municipio": "Burgos",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "145.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.50",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "e082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle zaratán  2   ",
        "district": "2807915",
        "postalCode": "28037",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "36.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "36.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "54.00",
        "surfaceTotal": "72.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ce7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "525.00",
        "askingPriceSale": "73500.00",
        "address": "Calle Marcelino Suarez  12   ",
        "postalCode": "32300",
        "city": "1132009",
        "municipio": "O Barco De Valdeorras",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.20",
        "surfaceTotal": "149.20",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "e07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "908.88",
        "askingPriceSale": "136332.00",
        "address": "Carretera de Gabriel Ciscar  1   ",
        "postalCode": "46780",
        "city": "1146181",
        "municipio": "Oliva",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "475.19",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "183.69",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "567.04",
        "surfaceTotal": "658.88",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "e87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1065.12",
        "askingPriceSale": "116497.50",
        "address": "Calle Carracido  4   ",
        "postalCode": "33900",
        "city": "1133900",
        "municipio": "Sama De Langreo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "111.25",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.88",
        "surfaceTotal": "222.50",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "f47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4977.70",
        "askingPriceSale": "650930.00",
        "address": "Calle Enric Prat De La Riba  155   ",
        "postalCode": "08901",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "9.02",
        "surfaceMezzanine": "0.00",
        "surfacepb": "548.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "550.86",
        "surfaceTotal": "557.17",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "f87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "688.80",
        "askingPriceSale": "114800.00",
        "address": "Calle Marqués De Pontejos  4   ",
        "postalCode": "15001",
        "city": "1115030",
        "municipio": "A Coruña",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.77",
        "surfaceTotal": "88.77",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "0a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1713.60",
        "askingPriceSale": "278460.00",
        "address": "Calle Pablo Picasso  7   ",
        "city": "1128130",
        "municipio": "San Fernando De Henares",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "0c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4953.90",
        "askingPriceSale": "707700.00",
        "address": "Calle Doutor Teixeiro  20   ",
        "postalCode": "15701",
        "city": "1115078",
        "municipio": "Santiago De Compostela",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "64.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "356.00",
        "surfaceTotal": "388.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "147de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "778.75",
        "askingPriceSale": "124600.00",
        "address": "Camino Del Magros  95   ",
        "postalCode": "03202",
        "city": "1103065",
        "municipio": "Elche/Elx",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "214.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "214.82",
        "surfaceTotal": "214.82",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "227de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "705.60",
        "askingPriceSale": "105840.00",
        "address": "Calle Mayor  38   ",
        "postalCode": "30100",
        "city": "1130100",
        "municipio": "Espinardo",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "390.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "390.16",
        "surfaceTotal": "390.16",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "267de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1423.17",
        "askingPriceSale": "189756.00",
        "address": "Calle El Rabal  26   ",
        "postalCode": "02400",
        "city": "1102037",
        "municipio": "Hellin",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "531.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "409.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "568.70",
        "surfaceTotal": "940.40",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "2c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "169.40",
        "askingPriceSale": "18480.00",
        "address": "Plaza Villa  45   ",
        "postalCode": "08760",
        "city": "1108114",
        "municipio": "Martorell",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "15.87",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "15.87",
        "surfaceTotal": "15.87",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "2e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "859.11",
        "askingPriceSale": "114548.00",
        "address": "Avenida De España  2   ",
        "city": "1131254",
        "municipio": "Villafranca",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "53.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "213.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "229.06",
        "surfaceTotal": "266.31",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "387de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2669.52",
        "askingPriceSale": "419496.00",
        "address": " Coso  102   ",
        "postalCode": "50001",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "241.93",
        "surfaceMezzanine": "0.00",
        "surfacepb": "257.07",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "329.65",
        "surfaceTotal": "499.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "4c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1212.12",
        "askingPriceSale": "202020.00",
        "address": "Paseo Del Altillo  3   ",
        "postalCode": "18690",
        "city": "1118017",
        "municipio": "Almuñecar",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "99.93",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.97",
        "surfaceTotal": "255.93",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "607de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1904.00",
        "askingPriceSale": "228480.00",
        "address": "Plaza Española  8   ",
        "postalCode": "08904",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "No",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "627de90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar,  39 - 41   ",
        "postalCode": "08902",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "3e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar,  39 - 41   ",
        "postalCode": "08902",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "40845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar,  39 - 41   ",
        "postalCode": "08902",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "42845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar,  39 - 41   ",
        "postalCode": "08902",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "44845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar,  39 - 41   ",
        "postalCode": "08902",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "787de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "1621.20",
        "askingPriceSale": "243180.00",
        "address": " Esperanza de Triana  41   ",
        "postalCode": "41010",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.45",
        "surfaceTotal": "180.45",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "987de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4301.50",
        "askingPriceSale": "739858.00",
        "address": "Calle Jose Abascal     ",
        "district": "2807907",
        "postalCode": "28003",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "75.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "97.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "58.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.50",
        "surfaceTotal": "230.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "9a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3696.00",
        "askingPriceSale": "672000.00",
        "address": "Calle Valderribas     ",
        "postalCode": "28007",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "78.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "183.35",
        "surfaceTotal": "222.70",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "VENTA",
        "askingPriceRent": "6272.00",
        "askingPriceSale": "1505280.00",
        "address": "Calle Sants  76   ",
        "postalCode": "08014",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.33",
        "surfaceTotal": "224.33",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1150.80",
        "askingPriceSale": "172620.00",
        "address": "Calle Constitución  37   ",
        "postalCode": "08014",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "74.33",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.63",
        "surfaceTotal": "148.66",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1505.00",
        "askingPriceSale": "210700.00",
        "address": "Calle Concepción  6   ",
        "postalCode": "46870",
        "city": "1146184",
        "municipio": "Onteniente/Ontinyent",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "289.13",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "39.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "308.63",
        "surfaceTotal": "328.13",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2142.00",
        "askingPriceSale": "333200.00",
        "address": "Carretera De Cornella  121   ",
        "postalCode": "08950",
        "city": "1108077",
        "municipio": "Esplugues De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "100.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "240.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c27de90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "askingPriceRent": "10885.88",
        "askingPriceSale": "2327325.00",
        "address": "Calle Rosendo Arus  39   ",
        "postalCode": "08901",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "114.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "45.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.17",
        "surfaceTotal": "281.71",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "de7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2816.02",
        "askingPriceSale": "530073.60",
        "address": "Avenida Reina Victoria  70   ",
        "district": "2807907",
        "postalCode": "28003",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "69.73",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "123.14",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.14",
        "surfaceTotal": "267.52",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6796.30",
        "askingPriceSale": "1395030.00",
        "address": "Calle O'Donell  43   ",
        "postalCode": "28009",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "115.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.50",
        "surfaceTotal": "315.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3613.75",
        "askingPriceSale": "702100.00",
        "address": "Calle Alcalá  205   ",
        "postalCode": "28028",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "33.08",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.02",
        "surfaceTotal": "175.18",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "578.76",
        "askingPriceSale": "66780.00",
        "address": "Avenida Pablo Iglesias  1   ",
        "postalCode": "47800",
        "city": "1147086",
        "municipio": "Medina De Rioseco",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "652.40",
        "askingPriceSale": "45668.00",
        "address": "Calle Conde De Garay  3   ",
        "postalCode": "34100",
        "city": "1134157",
        "municipio": "Saldaña",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "107ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2175.32",
        "askingPriceSale": "348051.20",
        "address": "Calle Eustasio Amilibia  12   ",
        "postalCode": "20011",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "3e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1181.60",
        "askingPriceSale": "177240.00",
        "address": " Obispo Romo  14   ",
        "postalCode": "35011",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "13.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.90",
        "surfaceTotal": "199.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "407ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "askingPriceRent": "633.92",
        "askingPriceSale": "95088.00",
        "address": "Calle San Salvador  1   ",
        "postalCode": "15402",
        "city": "1115036",
        "municipio": "Ferrol",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "87.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "87.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.10",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "7c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "697.20",
        "askingPriceSale": "92960.00",
        "address": "Calle Lorca     ",
        "postalCode": "30320",
        "city": "1102033",
        "municipio": "Fuente-Alamo",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.38",
        "surfaceTotal": "155.38",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "7e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1291.50",
        "askingPriceSale": "200900.00",
        "address": "Avenida Euskadi  28   ",
        "postalCode": "48902",
        "city": "1148013",
        "municipio": "Barakaldo",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.20",
        "surfaceTotal": "190.20",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "867ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "VENTA",
        "askingPriceRent": "264.60",
        "askingPriceSale": "35280.00",
        "address": "Calle Francesc Layret  59   ",
        "postalCode": "08100",
        "city": "1108124",
        "municipio": "Mollet Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.95",
        "surfaceTotal": "164.95",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "5a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "address": "Calle Marti I Codolar,  39 - 41   ",
        "postalCode": "08902",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "97.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.10",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "a67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2315.25",
        "askingPriceSale": "324135.00",
        "address": "Calle Nuevo  27   ",
        "postalCode": "41530",
        "city": "1141065",
        "municipio": "Moron De La Frontera",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "353.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "353.05",
        "surfaceTotal": "353.05",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "b27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1018.08",
        "askingPriceSale": "152712.00",
        "address": "Calle Juan Alvarado  9   ",
        "postalCode": "24100",
        "city": "1124202",
        "municipio": "Villablino",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "48.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.09",
        "surfaceTotal": "275.69",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "b67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1052.80",
        "askingPriceSale": "203980.00",
        "address": "Plaza De La Constitucion  10   ",
        "postalCode": "38300",
        "city": "1138026",
        "municipio": "La Orotava",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "c07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "364.00",
        "askingPriceSale": "54600.00",
        "address": " Tostado  1   ",
        "postalCode": "05220",
        "city": "1105114",
        "municipio": "Madrigal De Las Altas Torres",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "d67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1855.90",
        "askingPriceSale": "222564.80",
        "address": "Avenida Zumalacarregui  6   ",
        "postalCode": "20110",
        "city": "1120064",
        "municipio": "Pasaia - Pasajes",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.94",
        "surfaceTotal": "220.94",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "167de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1621.20",
        "askingPriceSale": "297220.00",
        "address": "Avenida Juan Carlos I  26   ",
        "postalCode": "03710",
        "city": "1103047",
        "municipio": "Calpe/Calp",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "78.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.46",
        "surfaceTotal": "248.20",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "1c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "16362.50",
        "askingPriceSale": "4775503.71",
        "address": "Gran Vía De Gracia  75   ",
        "postalCode": "08012",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "494.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "481.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "629.85",
        "surfaceTotal": "976.00",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "347de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1739.50",
        "askingPriceSale": "232505.00",
        "address": " Mayor  11   ",
        "postalCode": "45100",
        "city": "1145163",
        "municipio": "Sonseca",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "294.56",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "350.50",
        "surfaceTotal": "497.78",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "407de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "901.60",
        "askingPriceSale": "123970.00",
        "address": " Caballeros  3   ",
        "postalCode": "42200",
        "city": "1142020",
        "municipio": "Almazan",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.21",
        "surfaceTotal": "150.21",
        "timeAvailableFrom": "9/13/22 13:21"
    },
    {
        "id": "487de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "4099.20",
        "askingPriceSale": "614880.00",
        "address": "Calle Balmes  386   ",
        "postalCode": "08002",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "175.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "278.64",
        "surfaceTotal": "366.14",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "4e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1108.80",
        "askingPriceSale": "124740.00",
        "address": "Avenida De Gonzalez Mayo  30   ",
        "postalCode": "33870",
        "city": "1133073",
        "municipio": "Tineo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.00",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "647de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "900.90",
        "askingPriceSale": "124740.00",
        "address": "Avenida Condomina  19   ",
        "postalCode": "03002",
        "city": "1103014",
        "municipio": "Alicante/Alacant",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.58",
        "surfaceTotal": "143.58",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "6c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1984.50",
        "askingPriceSale": "340200.00",
        "address": " San Juan  62   ",
        "postalCode": "46020",
        "city": "1146205",
        "municipio": "Pucol",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "396.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "396.66",
        "surfaceTotal": "396.66",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "6e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1642.55",
        "askingPriceSale": "277970.00",
        "address": " Eugenio Gross  10   ",
        "postalCode": "29016",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "140.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "135.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "19.43",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "140.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.02",
        "surfaceTotal": "294.73",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "747de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "839.48",
        "askingPriceSale": "129150.00",
        "address": " La Reina  166   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "847de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1292.59",
        "askingPriceSale": "215432.00",
        "address": " Gerona  25   ",
        "postalCode": "08400",
        "city": "1108096",
        "municipio": "Granollers",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "100.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.88",
        "surfaceTotal": "243.88",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "887de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2847.60",
        "askingPriceSale": "427140.00",
        "address": " Francisco Ruiz  9   ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Almacén",
        "smokeStractor": undefined,
        "surfacebr": "3209.98",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "962.99",
        "surfaceTotal": "3209.98",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "8a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "303.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "303.76",
        "surfaceTotal": "303.76",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "46845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.74",
        "surfaceTotal": "186.74",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "48845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "10.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.24",
        "surfaceTotal": "10.80",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "4a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.70",
        "surfaceTotal": "186.70",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "4c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.26",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.26",
        "surfaceTotal": "215.26",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "4e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "244.27",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "244.27",
        "surfaceTotal": "244.27",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "50845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "306.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "306.80",
        "surfaceTotal": "306.80",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "52845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia  23   ",
        "postalCode": "46002",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "10.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.10",
        "surfaceTotal": "10.35",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "8c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "3255.00",
        "askingPriceSale": "524300.00",
        "address": " Miguel Barcelo  2   ",
        "postalCode": "43730",
        "city": "1143055",
        "municipio": "Falset",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "85.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "463.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.04",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "553.27",
        "surfaceTotal": "677.10",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "8e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1372.00",
        "askingPriceSale": "205800.00",
        "address": " Real 14Planta.  2   ",
        "postalCode": "14400",
        "city": "1114054",
        "municipio": "Pozoblanco",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "230.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "230.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "913.50",
        "askingPriceSale": "127286.93",
        "address": " Edificio Plaza De La Cruz  6   ",
        "postalCode": "08700",
        "city": "1108102",
        "municipio": "Igualada",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3024.00",
        "askingPriceSale": "504000.00",
        "address": "Calle de San Germán,  43   ",
        "district": "2807906",
        "postalCode": "28020",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.86",
        "surfaceTotal": "227.86",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1338.28",
        "askingPriceSale": "259896.00",
        "address": " Real  76   ",
        "postalCode": "28700",
        "city": "1128134",
        "municipio": "San Sebastian De Los Reyes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "103.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.95",
        "surfaceTotal": "259.40",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Michelena  26   ",
        "postalCode": "36002",
        "city": "1136038",
        "municipio": "Pontevedra",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Vivienda",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "0.00",
        "surfaceTotal": "0.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1295.00",
        "askingPriceSale": "207200.00",
        "address": " Cerdeña  76-84   ",
        "postalCode": "08830",
        "city": "1108200",
        "municipio": "Sant Boi De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "fa7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "277.20",
        "askingPriceSale": "47124.00",
        "address": " Felix Rguez. De La Fuente  1-3   ",
        "postalCode": "41920",
        "city": "1141086",
        "municipio": "San Juan De Aznalfarache",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "fc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "373.68",
        "askingPriceSale": "47880.00",
        "address": "Avenida Castilla Y Leon,  2   ",
        "postalCode": "34200",
        "city": "1134023",
        "municipio": "Venta De Baños",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "65.47",
        "surfaceTotal": "65.47",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "087ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6366.50",
        "askingPriceSale": "1154288.66",
        "address": " Lealtad  21   ",
        "postalCode": "39002",
        "city": "1139075",
        "municipio": "Santander",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "262.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "262.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "393.00",
        "surfaceTotal": "524.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "187ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "address": " Martinez Padin  2   ",
        "postalCode": "36700",
        "city": "1136055",
        "municipio": "Tui",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "157.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "165.65",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "204.10",
        "surfaceTotal": "314.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "227ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "699.72",
        "askingPriceSale": "98784.00",
        "address": "Avenida Chapi  2   ",
        "postalCode": "03600",
        "city": "1103066",
        "municipio": "Elda",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "327ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1948.80",
        "askingPriceSale": "259840.00",
        "address": "Calle Angli  39   ",
        "postalCode": "08017",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "607ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "791.00",
        "askingPriceSale": "126560.00",
        "address": "Plaza España  5   ",
        "postalCode": "11130",
        "city": "1111015",
        "municipio": "Chiclana De La Frontera",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "114.04",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "114.04",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "347.02",
        "surfaceTotal": "404.04",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "3481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1708.00",
        "askingPriceSale": "257552.89",
        "address": " Huelva  S/N   ",
        "postalCode": "21004",
        "city": "1121041",
        "municipio": "Huelva",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.77",
        "surfaceTotal": "99.77",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "727ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2431.80",
        "askingPriceSale": "351260.00",
        "address": "Calle Mendizabal  10   ",
        "postalCode": "35001",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "7a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2364.60",
        "askingPriceSale": "315280.00",
        "address": " Fuentemar  43   ",
        "postalCode": "28820",
        "city": "1128049",
        "municipio": "Coslada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Nave industrial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "209.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "105.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.31",
        "surfaceTotal": "314.86",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "8a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1106.00",
        "askingPriceSale": "159264.00",
        "address": " General De Palafox  5   ",
        "postalCode": "08860",
        "city": "1108056",
        "municipio": "Castelldefels",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.75",
        "surfaceTotal": "134.75",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "8c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "87920.00",
        "address": "Carretera Castilla  107   ",
        "postalCode": "15407",
        "city": "1115054",
        "municipio": "Naron",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "8e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "729.12",
        "askingPriceSale": "97216.00",
        "address": " Carlos Iii     ",
        "postalCode": "14120",
        "city": "1114030",
        "municipio": "Fuente Palmera",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.60",
        "surfaceTotal": "173.60",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "907ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "address": "Paseo De Las Delicias  51   ",
        "postalCode": "28045",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "927ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "693.00",
        "askingPriceSale": "101640.00",
        "address": "Plaza De España  2   ",
        "postalCode": "41567",
        "city": "1141050",
        "municipio": "Herrera",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "105.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "105.00",
        "surfaceTotal": "105.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "947ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2310.00",
        "askingPriceSale": "420000.00",
        "address": "Avenida De La Industria  6   ",
        "postalCode": "28108",
        "city": "1128006",
        "municipio": "Alcobendas",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "967ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "4941.72",
        "askingPriceSale": "1043252.00",
        "address": "Calle Maldonado  31   ",
        "district": "2807905",
        "postalCode": "28006",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "53.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "77.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "53.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "92.90",
        "surfaceTotal": "130.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "987ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1557.71",
        "askingPriceSale": "274890.00",
        "address": " Mar De Aral  9   ",
        "district": "2807916",
        "postalCode": "28033",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "237.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.36",
        "surfaceTotal": "237.36",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "9a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2701.44",
        "askingPriceSale": "383061.25",
        "address": "Avenida Marques De Corbera  15   ",
        "postalCode": "28017",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "144.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "144.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.20",
        "surfaceTotal": "432.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "9c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1344.00",
        "askingPriceSale": "201600.00",
        "address": "Calle Moquetas  1   ",
        "district": "2807908",
        "postalCode": "28029",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.90",
        "surfaceTotal": "120.90",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "9e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1740.48",
        "askingPriceSale": "323232.00",
        "address": "Calle Mota Del Cuervo  21   ",
        "district": "2807916",
        "postalCode": "28043",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "121.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.48",
        "surfaceTotal": "273.82",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4916.80",
        "askingPriceSale": "737520.00",
        "address": "Avenida Ntra. Sra. Fátima  4   ",
        "district": "2807910",
        "postalCode": "28047",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "471.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "471.00",
        "surfaceTotal": "471.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1565.20",
        "askingPriceSale": "267288.00",
        "address": "Calle Nuestra Señora De Valverde,  25   ",
        "district": "2807908",
        "postalCode": "28034",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5500.00",
        "askingPriceSale": "1809360.00",
        "address": "Calle Nuñez De Balboa  61   ",
        "district": "2807904",
        "postalCode": "28001",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "278.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "50.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "303.00",
        "surfaceTotal": "328.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a67ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "4054.62",
        "askingPriceSale": "750855.00",
        "address": "Avenida Presidente Carmona  10   ",
        "postalCode": "28020",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "104.12",
        "surfaceMezzanine": "0.00",
        "surfacepb": "204.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "104.12",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.36",
        "surfaceTotal": "308.24",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "a87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "4048.80",
        "askingPriceSale": "769272.00",
        "address": "Calle Puenteareas  17   ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "No",
        "surfacebr": "235.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "263.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "333.50",
        "surfaceTotal": "498.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "aa7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1456.02",
        "askingPriceSale": "216264.36",
        "address": "Avenida Real De Pinto  13   ",
        "district": "2807917",
        "postalCode": "28021",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "141.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.45",
        "surfaceTotal": "141.45",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ac7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2926.00",
        "askingPriceSale": "523600.00",
        "address": "Calle Sanchez Barcaiztegui  4   ",
        "district": "2807903",
        "postalCode": "28007",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "218.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.28",
        "surfaceTotal": "218.28",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ae7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1512.00",
        "askingPriceSale": "196560.00",
        "address": "Calle Sierra Contraviesa  28   ",
        "district": "2807913",
        "postalCode": "28053",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.75",
        "surfaceTotal": "203.75",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2734.20",
        "askingPriceSale": "468720.00",
        "address": "Calle Sierra Vieja  72   ",
        "district": "2807918",
        "postalCode": "28031",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "279.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "279.00",
        "surfaceTotal": "279.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2771.19",
        "askingPriceSale": "320874.40",
        "address": "Calle Valdecanillas  35   ",
        "district": "2807915",
        "postalCode": "28037",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "208.00",
        "surfaceTotal": "208.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3640.00",
        "askingPriceSale": "746200.00",
        "address": "Calle Doctor Esquerdo  6   ",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "111.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "63.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.30",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1115.10",
        "askingPriceSale": "123900.00",
        "address": "Calle Jaime Janer  24   ",
        "postalCode": "36900",
        "city": "1136026",
        "municipio": "Marin",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.00",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "b87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "966.00",
        "askingPriceSale": "115920.00",
        "address": "Avenida Pablo Iglesias  2   ",
        "postalCode": "47800",
        "city": "1147086",
        "municipio": "Medina De Rioseco",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "263.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.67",
        "surfaceTotal": "263.67",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ba7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1300.89",
        "askingPriceSale": "216814.50",
        "address": "Paseo Del Terraple  25   ",
        "postalCode": "08750",
        "city": "1108123",
        "municipio": "Molins De Rei",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "163.86",
        "surfaceTotal": "163.86",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "bc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "346.88",
        "askingPriceSale": "46375.00",
        "address": "Plaza De España  6   ",
        "postalCode": "09100",
        "city": "1109211",
        "municipio": "Melgar De Fernamental",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "be7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1390.98",
        "askingPriceSale": "199953.95",
        "address": "Avenida De Galicia  34   ",
        "postalCode": "27400",
        "city": "1127031",
        "municipio": "Monforte De Lemos",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "55.17",
        "surfacepb": "220.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "55.17",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.39",
        "surfaceTotal": "275.97",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4038.30",
        "askingPriceSale": "477855.00",
        "address": "Calle Carrera  17   ",
        "postalCode": "23600",
        "city": "1123060",
        "municipio": "Martos",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "419.83",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "153.17",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "380.51",
        "surfaceTotal": "750.98",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "595.00",
        "askingPriceSale": "89250.00",
        "address": "Calle Gregorio Solabarrieta  1   ",
        "postalCode": "09200",
        "city": "1109219",
        "municipio": "Miranda De Ebro",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "277.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "247.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "330.65",
        "surfaceTotal": "524.90",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1254.40",
        "askingPriceSale": "211680.00",
        "address": "Calle Floridablanca  3   ",
        "postalCode": "30002",
        "city": "1130030",
        "municipio": "Murcia",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.00",
        "surfaceTotal": "280.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1204.00",
        "askingPriceSale": "192640.00",
        "address": "Calle Ronda De Levante  49   ",
        "postalCode": "30008",
        "city": "1130030",
        "municipio": "Murcia",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.60",
        "surfaceTotal": "171.60",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "c87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "814.80",
        "askingPriceSale": "135800.00",
        "address": "Plaza Bages  15   ",
        "postalCode": "08242",
        "city": "1108113",
        "municipio": "Manresa",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "205.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "114.66",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.66",
        "surfaceTotal": "319.99",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ca7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1322.72",
        "askingPriceSale": "198408.00",
        "address": "Paseo Pere lii  6   ",
        "postalCode": "08240",
        "city": "1108113",
        "municipio": "Manresa",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "102.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "360.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "118.10",
        "surfacesr": "118.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "450.21",
        "surfaceTotal": "581.22",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "cc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "730.80",
        "askingPriceSale": "103530.00",
        "address": "Calle Glorieta  5   ",
        "postalCode": "04638",
        "city": "1104064",
        "municipio": "Mojacar",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.00",
        "surfaceTotal": "87.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ce7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "157164.00",
        "address": "Plaza De La Constitucion  1   ",
        "postalCode": "30500",
        "city": "1130027",
        "municipio": "Molina De Segura",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "151.89",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.20",
        "surfaceTotal": "321.52",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1293.60",
        "askingPriceSale": "176960.00",
        "address": "Avenida Torres Murciano  10   ",
        "postalCode": "29600",
        "city": "1129069",
        "municipio": "Marbella",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "39.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "77.41",
        "surfaceTotal": "104.95",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "347.20",
        "askingPriceSale": "52080.00",
        "address": "Calle Maria Fortuny  1   ",
        "postalCode": "08110",
        "city": "1108125",
        "municipio": "Montcada I Reixac",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "56.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "56.00",
        "surfaceTotal": "56.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "875.14",
        "askingPriceSale": "139650.00",
        "address": "Calle Santos Justo Y Pastor  3   ",
        "postalCode": "46940",
        "city": "1146159",
        "municipio": "Manises",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "70.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "60.10",
        "surfacesr": "60.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.05",
        "surfaceTotal": "130.10",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1645.00",
        "askingPriceSale": "298060.00",
        "address": "Calle Riber  38   ",
        "postalCode": "43400",
        "city": "1143086",
        "municipio": "Montblanc",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "16.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "91.38",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.87",
        "surfaceTotal": "203.76",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "d87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1675.80",
        "askingPriceSale": "299880.00",
        "address": "Paseo Ramon Berenguer  133   ",
        "postalCode": "08303",
        "city": "1108121",
        "municipio": "Mataro",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.24",
        "surfaceTotal": "220.24",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "da7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "882.00",
        "askingPriceSale": "126000.00",
        "address": "Calle La Corredera  40   ",
        "postalCode": "14550",
        "city": "1114042",
        "municipio": "Montilla",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "206.86",
        "surfaceMezzanine": "0.00",
        "surfacepb": "283.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "345.56",
        "surfaceTotal": "490.36",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "dc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "askingPriceRent": "1453.20",
        "askingPriceSale": "169540.00",
        "address": "Calle Juan Ramon Jimenez  6   ",
        "postalCode": "21800",
        "city": "1121050",
        "municipio": "Moguer",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "304.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "304.00",
        "surfaceTotal": "304.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "de7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "address": "Plaza Alta  12   ",
        "postalCode": "11201",
        "city": "1111004",
        "municipio": "Algeciras",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "40.00",
        "surfacepb": "267.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "40.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "287.00",
        "surfaceTotal": "307.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "705.60",
        "askingPriceSale": "90720.00",
        "address": "Calle Real  5   ",
        "postalCode": "28410",
        "city": "1128082",
        "municipio": "Manzanares El Real",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "72.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "72.00",
        "surfaceTotal": "72.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "929.60",
        "askingPriceSale": "139440.00",
        "address": "Calle Regueral  2   ",
        "postalCode": "33710",
        "city": "1133041",
        "municipio": "Navia",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "140.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.67",
        "surfaceTotal": "283.67",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1782.90",
        "askingPriceSale": "277340.00",
        "address": "Calle Via Canetum  6   ",
        "postalCode": "08360",
        "city": "1108040",
        "municipio": "Canet De Mar",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "257.46",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.46",
        "surfaceTotal": "257.46",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "54845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "address": "Plaza Alta  12   ",
        "postalCode": "11201",
        "city": "1111004",
        "municipio": "Algeciras",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "270.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "270.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "270.00",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "e67ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "address": "Calle El Parque  4   ",
        "postalCode": "04100",
        "city": "1104066",
        "municipio": "Nijar",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.35",
        "surfaceTotal": "137.35",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "e87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "address": "Avenida España  4   ",
        "postalCode": "11205",
        "city": "1111004",
        "municipio": "Algeciras",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.88",
        "surfaceTotal": "112.88",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ec7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1167.60",
        "askingPriceSale": "175140.00",
        "address": "Glorieta Amadora  s/n   ",
        "postalCode": "14011",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "141.05",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "141.05",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.94",
        "surfaceTotal": "265.67",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "ee7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1503.60",
        "askingPriceSale": "200480.00",
        "address": "Camino De Los Sastres  3-5   ",
        "postalCode": "14004",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.56",
        "surfaceTotal": "179.56",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1251.60",
        "askingPriceSale": "166880.00",
        "address": "Avenida Conde Vallellano  17   ",
        "postalCode": "14004",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.00",
        "surfaceTotal": "149.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1251.48",
        "askingPriceSale": "183260.00",
        "address": "Avenida Cruz Juarez  10   ",
        "postalCode": "14006",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.00",
        "surfaceTotal": "187.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "135240.00",
        "address": "Calle Cuesta De La Polvora  2   ",
        "postalCode": "14010",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.93",
        "surfaceTotal": "160.93",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "886.90",
        "askingPriceSale": "126700.00",
        "address": "Avenida D'Alacant  21   ",
        "postalCode": "03760",
        "city": "1103095",
        "municipio": "Ondara",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "f87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "1358.00",
        "askingPriceSale": "190120.00",
        "address": "Calle Rua Agro Do Medio  6   ",
        "postalCode": "15895",
        "city": "1115411",
        "municipio": "O Milladoiro",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "177.00",
        "surfaceTotal": "177.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "fa7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "40740.00",
        "address": "Avenida Alfonso Molina  63   ",
        "postalCode": "15186",
        "city": "1115077",
        "municipio": "Santa Comba",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "fc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1413.72",
        "askingPriceSale": "240856.00",
        "address": "Calle Cervantes  17   ",
        "postalCode": "33004",
        "city": "1133044",
        "municipio": "Oviedo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "72.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "127.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.55",
        "surfaceTotal": "200.23",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "fe7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "220500.00",
        "address": "Calle Fray Ceferino  40   ",
        "postalCode": "33011",
        "city": "1133044",
        "municipio": "Oviedo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.25",
        "surfaceTotal": "154.25",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "027fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "560.00",
        "askingPriceSale": "98000.00",
        "address": "Avenida Aureliano San Roman  41   ",
        "postalCode": "33011",
        "city": "1133044",
        "municipio": "Oviedo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "80.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "80.00",
        "surfaceTotal": "80.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "047fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "63168.00",
        "address": "Avenida De Navarra  31   ",
        "postalCode": "01320",
        "city": "1101043",
        "municipio": "Oyon",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.00",
        "surfaceTotal": "94.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "067fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "6439.16",
        "askingPriceSale": "792512.00",
        "address": "Avenida Antonio Machado  29   ",
        "postalCode": "29630",
        "city": "1129631",
        "municipio": "Arroyo De La Miel",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "428.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "407.59",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "428.40",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "536.11",
        "surfaceTotal": "835.99",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "087fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "980.98",
        "askingPriceSale": "146510.00",
        "address": "Avenida Federico Garcia Lorca  37   ",
        "postalCode": "29630",
        "city": "1129631",
        "municipio": "Arroyo De La Miel",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "91.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "91.00",
        "surfaceTotal": "91.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "0a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3234.00",
        "askingPriceSale": "602564.01",
        "address": " Cataluña  200   ",
        "postalCode": "08184",
        "city": "1108156",
        "municipio": "Palau De Plegamans",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "308.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "308.00",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "0c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5313.00",
        "askingPriceSale": "1030400.00",
        "address": "Avenida Gabriel Alomar I Villalonga,  6   ",
        "postalCode": "07002",
        "city": "1107040",
        "municipio": "Palma De Mallorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "456.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "456.00",
        "surfaceTotal": "456.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "0e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3731.42",
        "askingPriceSale": "576674.00",
        "address": "Avenida De Bayona  37   ",
        "postalCode": "31011",
        "city": "1131201",
        "municipio": "Pamplona/Iruña",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "119.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.35",
        "surfaceTotal": "346.65",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "107fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1729.50",
        "askingPriceSale": "281044.40",
        "address": "Calle Felipe Gorriti  31   ",
        "postalCode": "31004",
        "city": "1131201",
        "municipio": "Pamplona/Iruña",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "127fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "793.80",
        "askingPriceSale": "90720.00",
        "address": "Calle Capitan Rojas  34   ",
        "postalCode": "47300",
        "city": "1147114",
        "municipio": "Peñafiel",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.00",
        "surfaceTotal": "187.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "147fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "716.80",
        "askingPriceSale": "100800.00",
        "address": "Calle Larrinaga  1   ",
        "postalCode": "01470",
        "city": "1101002",
        "municipio": "Amurrio",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.00",
        "surfaceTotal": "175.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "167fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "602.70",
        "askingPriceSale": "86100.00",
        "address": "Avenida De La Martina  30   ",
        "postalCode": "24400",
        "city": "1124115",
        "municipio": "Ponferrada",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.69",
        "surfaceTotal": "167.69",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "187fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "VENTA",
        "askingPriceRent": "972.16",
        "askingPriceSale": "138880.00",
        "address": "Avenida Galicia  82   ",
        "postalCode": "24400",
        "city": "1124115",
        "municipio": "Ponferrada",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "129.00",
        "surfaceTotal": "129.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "1a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "234155.25",
        "address": "Calle Estrella Antares  7   ",
        "postalCode": "28983",
        "city": "1128106",
        "municipio": "Parla",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.00",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:22"
    },
    {
        "id": "1c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1329.16",
        "askingPriceSale": "249217.50",
        "address": "Calle Juan Tadeo Cabrera  8   ",
        "postalCode": "35600",
        "city": "1135017",
        "municipio": "Puerto Del Rosario",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "80.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.35",
        "surfaceTotal": "237.35",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1281.50",
        "askingPriceSale": "212249.10",
        "address": "Calle Talavera  26   ",
        "postalCode": "10600",
        "city": "1110148",
        "municipio": "Plasencia",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "486.07",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "529.09",
        "surfaceTotal": "772.12",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "207fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Oceano  S/N   ",
        "postalCode": "11500",
        "city": "1111027",
        "municipio": "El Puerto De Santa Maria",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.40",
        "surfaceTotal": "161.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "227fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "976.50",
        "askingPriceSale": "151900.00",
        "address": "Calle Font Del Gerro  65   ",
        "postalCode": "46980",
        "city": "1146190",
        "municipio": "Paterna",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.88",
        "surfaceTotal": "150.88",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "247fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2240.00",
        "askingPriceSale": "350000.00",
        "address": "Calle Concepcion  7   ",
        "postalCode": "28223",
        "city": "1128115",
        "municipio": "Pozuelo De Alarcon",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "105.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "85.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.50",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "267fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2128.00",
        "askingPriceSale": "350016.35",
        "address": "Calle Hibisco  1   ",
        "postalCode": "35660",
        "city": "1135660",
        "municipio": "Corralejo",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "379.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "379.00",
        "surfaceTotal": "379.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "287fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1218.00",
        "askingPriceSale": "194880.00",
        "address": "Calle Carretera De Sabadell  18   ",
        "postalCode": "08191",
        "city": "1108184",
        "municipio": "Rubi",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.77",
        "surfaceTotal": "173.77",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1201.20",
        "askingPriceSale": "200200.00",
        "address": "Plaza Onze De Septiembre  2   ",
        "postalCode": "08291",
        "city": "1108180",
        "municipio": "Ripollet",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.32",
        "surfaceTotal": "121.32",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "963.20",
        "askingPriceSale": "132440.00",
        "address": "Avenida Aduana  16   ",
        "postalCode": "04740",
        "city": "1104079",
        "municipio": "Roquetas De Mar",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "214.73",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "19.43",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.45",
        "surfaceTotal": "234.16",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1293.60",
        "askingPriceSale": "184800.00",
        "address": "Calle Caja De Ahorros  13   ",
        "postalCode": "46900",
        "city": "1117197",
        "municipio": "Torrent",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "197.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "197.31",
        "surfaceTotal": "197.31",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "307fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1888.74",
        "askingPriceSale": "209860.00",
        "address": "Avenida De Navarra  26   ",
        "postalCode": "20100",
        "city": "1120067",
        "municipio": "Renteria",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "327fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1759.38",
        "askingPriceSale": "208740.00",
        "address": "Plaza De La Llibertat  1   ",
        "postalCode": "43201",
        "city": "1143123",
        "municipio": "Reus",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "213.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "213.00",
        "surfaceTotal": "213.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "347fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1421.00",
        "askingPriceSale": "205800.00",
        "address": "Calle Cincel  4   ",
        "postalCode": "28522",
        "city": "1128123",
        "municipio": "Rivas-Vaciamadrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "367fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "7815.79",
        "askingPriceSale": "1338152.90",
        "address": "Plaza De Vigo  1   ",
        "postalCode": "15706",
        "city": "1115078",
        "municipio": "Santiago De Compostela",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "460.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "460.00",
        "surfaceTotal": "460.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "387fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4365.90",
        "askingPriceSale": "582120.00",
        "address": "Avenida De Catalunya  20   ",
        "postalCode": "08172",
        "city": "1108205",
        "municipio": "Sant Cugat Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "6.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "6.00",
        "surfaceWeighted": "292.38",
        "surfaceTotal": "296.58",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "700.00",
        "askingPriceSale": "114800.00",
        "address": "Avenida De Los Majuelos  69   ",
        "postalCode": "38107",
        "city": "1138038",
        "municipio": "Santa Cruz De Tenerife",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "36.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.83",
        "surfaceTotal": "211.51",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "492.62",
        "askingPriceSale": "69930.00",
        "address": "Carretera General Del Sur     ",
        "postalCode": "38107",
        "city": "1138190",
        "municipio": "Taco",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.00",
        "surfaceTotal": "113.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1366.40",
        "askingPriceSale": "239120.00",
        "address": "Calle General Davila  256   ",
        "postalCode": "39006",
        "city": "1139075",
        "municipio": "Santander",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.70",
        "surfaceTotal": "121.70",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "407fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1410.50",
        "askingPriceSale": "191100.00",
        "address": "Calle Motrico  11   ",
        "postalCode": "28830",
        "city": "1128130",
        "municipio": "San Fernando De Henares",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.53",
        "surfaceTotal": "137.53",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "427fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1456.00",
        "askingPriceSale": "218400.00",
        "address": "Calle Rutlla  20   ",
        "postalCode": "17220",
        "city": "1117160",
        "municipio": "Sant Feliu De Guixols",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "447fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "824.60",
        "askingPriceSale": "124775.00",
        "address": "Avenida Antonio Machado  4   ",
        "postalCode": "18680",
        "city": "1118173",
        "municipio": "Salobreña",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.37",
        "surfaceTotal": "155.37",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "467fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida De Lasalle  43   ",
        "postalCode": "37008",
        "city": "1137274",
        "municipio": "Salamanca",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "43.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.63",
        "surfaceTotal": "43.63",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "487fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2037.00",
        "askingPriceSale": "305550.00",
        "address": "Avenida Raimundo De Borgoña  1-15   ",
        "postalCode": "37005",
        "city": "1137274",
        "municipio": "Salamanca",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "278.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "278.50",
        "surfaceTotal": "278.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1347.29",
        "askingPriceSale": "188620.60",
        "address": "Carretera Nacional-340  km146   ",
        "postalCode": "29692",
        "city": "1129068",
        "municipio": "Manilva",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "192.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "192.47",
        "surfaceTotal": "192.47",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "548.80",
        "askingPriceSale": "75460.00",
        "address": "Calle Corredera Alta  2   ",
        "postalCode": "28680",
        "city": "1128133",
        "municipio": "San Martin De Valdeiglesias",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2921.52",
        "askingPriceSale": "389536.00",
        "address": "Calle Infante Don Fernando  21   ",
        "postalCode": "29200",
        "city": "1129015",
        "municipio": "Antequera",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "65.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "479.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "389.90",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "693.68",
        "surfaceTotal": "934.13",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "507fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1158.00",
        "askingPriceSale": "154400.40",
        "address": "Avenida Artero Guirao  120   ",
        "postalCode": "30740",
        "city": "1130036",
        "municipio": "San Pedro Del Pinatar",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "184.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "184.00",
        "surfaceTotal": "184.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "527fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1194.49",
        "askingPriceSale": "189371.00",
        "address": "Avenida De Los Quiñones  1   ",
        "postalCode": "28702",
        "city": "1128134",
        "municipio": "San Sebastian De Los Reyes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.05",
        "surfaceTotal": "104.05",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "547fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "534.80",
        "askingPriceSale": "90916.00",
        "address": "Avenida Valdelasfuentes  9   ",
        "postalCode": "28700",
        "city": "1128134",
        "municipio": "San Sebastian De Los Reyes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "76.40",
        "surfaceTotal": "76.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "567fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "588.00",
        "askingPriceSale": "88200.00",
        "address": "Calle Jacint Verdaguer  278   ",
        "postalCode": "08620",
        "city": "1108263",
        "municipio": "Sant Vicenc Dels Horts",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.40",
        "surfaceTotal": "99.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "587fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "1806.00",
        "askingPriceSale": "319200.00",
        "address": "Calle Dr.Jimenez Diaz  6   ",
        "postalCode": "41008",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "109.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.82",
        "surfaceTotal": "217.67",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1478.40",
        "askingPriceSale": "221760.00",
        "address": "Avenida Hytasa  61   ",
        "postalCode": "41006",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.00",
        "surfaceTotal": "264.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "VENTA",
        "askingPriceRent": "646.80",
        "askingPriceSale": "92400.00",
        "address": "Calle Gramil  15   ",
        "postalCode": "41008",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Nave industrial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.00",
        "surfaceTotal": "132.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2530.50",
        "askingPriceSale": "371140.00",
        "address": "Calle Recaredo  5   ",
        "postalCode": "41003",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "94.75",
        "surfacepb": "196.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "94.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "244.07",
        "surfaceTotal": "291.44",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "607fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2406.60",
        "askingPriceSale": "347620.00",
        "address": "Calle Riera Del Bisbe Pol  5   ",
        "postalCode": "08350",
        "city": "1108006",
        "municipio": "Arenys De Mar",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.00",
        "surfaceTotal": "181.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "627fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1659.00",
        "askingPriceSale": "309680.00",
        "address": "Paseo De Larios  1   ",
        "postalCode": "29740",
        "city": "1129740",
        "municipio": "Torre De Mar",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "647fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "936.60",
        "askingPriceSale": "124880.00",
        "address": "Calle Capitan Cortes  9   ",
        "postalCode": "45600",
        "city": "1145165",
        "municipio": "Talavera De La Reina",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "207.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "207.71",
        "surfaceTotal": "207.71",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "667fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "840.00",
        "askingPriceSale": "121800.00",
        "address": "Calle Rafael Quintana  16   ",
        "postalCode": "29620",
        "city": "1129901",
        "municipio": "Torremolinos",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.40",
        "surfaceTotal": "100.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "687fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "573.30",
        "askingPriceSale": "70560.00",
        "address": "Avenida Maestro Serrano  1   ",
        "postalCode": "46290",
        "city": "1146015",
        "municipio": "Alcacer",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.94",
        "surfaceTotal": "118.94",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1125.60",
        "askingPriceSale": "126630.00",
        "address": "Travesía General Riego  s/n   ",
        "postalCode": "33870",
        "city": "1133073",
        "municipio": "Tineo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.00",
        "surfaceTotal": "194.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "803.88",
        "askingPriceSale": "126672.00",
        "address": "Avenida Diego Ramirez Pastor  22   ",
        "postalCode": "03181",
        "city": "1103133",
        "municipio": "Torrevieja",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.40",
        "surfaceTotal": "169.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "839.20",
        "askingPriceSale": "127995.00",
        "address": "Avenida Estación  32   ",
        "postalCode": "30700",
        "city": "1130037",
        "municipio": "Torre-Pacheco",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.50",
        "surfaceTotal": "158.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "707fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "975.39",
        "askingPriceSale": "158172.00",
        "address": "Calle Independencia  44   ",
        "postalCode": "08225",
        "city": "1108279",
        "municipio": "Terrassa",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "188.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.30",
        "surfaceTotal": "188.30",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "727fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1136.80",
        "askingPriceSale": "194880.00",
        "address": "Plaza Del Toro  S/N   ",
        "postalCode": "28760",
        "city": "1128903",
        "municipio": "Tres Cantos",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.30",
        "surfaceTotal": "112.30",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "747fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "804.65",
        "askingPriceSale": "118580.00",
        "address": "Calle Roma  3   ",
        "postalCode": "28850",
        "city": "1128148",
        "municipio": "Torrejon De Ardoz",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "129.30",
        "surfaceTotal": "129.30",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "767fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1844.50",
        "askingPriceSale": "271250.00",
        "address": "Calle Pelotari  7   ",
        "postalCode": "20115",
        "city": "1120903",
        "municipio": "Astigarraga",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "787fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "851.20",
        "askingPriceSale": "138320.00",
        "address": "Calle Sanchez Llevot  10   ",
        "postalCode": "37800",
        "city": "1137008",
        "municipio": "Alba De Tormes",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "115.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.50",
        "surfaceTotal": "260.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "674.10",
        "askingPriceSale": "97370.00",
        "address": "Avenida De Palencia  9   ",
        "postalCode": "39300",
        "city": "1139087",
        "municipio": "Torrelavega",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.02",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.02",
        "surfaceTotal": "94.02",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1131.20",
        "askingPriceSale": "175336.00",
        "address": "Plaza De Colon  5   ",
        "postalCode": "11600",
        "city": "1111038",
        "municipio": "Ubrique",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1367.10",
        "askingPriceSale": "197470.00",
        "address": "Calle 18 De Julio  30   ",
        "postalCode": "39610",
        "city": "1139008",
        "municipio": "El Astillero",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.43",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.43",
        "surfaceTotal": "255.43",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "807fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "723.80",
        "askingPriceSale": "101640.00",
        "address": "Calle Carrera  3   ",
        "postalCode": "23330",
        "city": "1123097",
        "municipio": "Villanueva Del Arzobispo",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "168.78",
        "surfaceMezzanine": "0.00",
        "surfacepb": "168.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.41",
        "surfaceTotal": "337.56",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "827fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1584.66",
        "askingPriceSale": "226380.00",
        "address": "Calle Comandante Albarran  6   ",
        "postalCode": "05001",
        "city": "1105019",
        "municipio": "Avila",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "53.96",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "239.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.19",
        "surfaceTotal": "412.46",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "847fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1778.00",
        "askingPriceSale": "284480.00",
        "address": "Calle De Modolell  52   ",
        "postalCode": "08840",
        "city": "1108301",
        "municipio": "Viladecans",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.30",
        "surfaceTotal": "231.30",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "867fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1170.40",
        "askingPriceSale": "170240.00",
        "address": "Avenida Luis Espada  51   ",
        "postalCode": "32600",
        "city": "1132085",
        "municipio": "Verin",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.42",
        "surfaceTotal": "280.42",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "887fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2205.00",
        "askingPriceSale": "378000.00",
        "address": " Gran Via  55   ",
        "postalCode": "36209",
        "city": "1136057",
        "municipio": "Vigo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "787.50",
        "askingPriceSale": "113750.00",
        "address": "Calle Boulevar Ciudad De Vicar,  619   ",
        "postalCode": "04738",
        "city": "1104102",
        "municipio": "Vicar",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.00",
        "surfaceTotal": "119.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1364.16",
        "askingPriceSale": "258720.00",
        "address": "Calle Canciller Ayala  9   ",
        "postalCode": "01004",
        "city": "1101059",
        "municipio": "Vitoria/Gasteiz",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.93",
        "surfaceTotal": "158.93",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1406.16",
        "askingPriceSale": "272160.00",
        "address": "Calle Domingo Beltran  50   ",
        "postalCode": "01012",
        "city": "1101059",
        "municipio": "Vitoria/Gasteiz",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.83",
        "surfaceTotal": "156.83",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "907fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1518.72",
        "askingPriceSale": "297416.00",
        "address": "Calle Francia  25   ",
        "postalCode": "01004",
        "city": "1101059",
        "municipio": "Vitoria/Gasteiz",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "927fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1448.72",
        "askingPriceSale": "278600.00",
        "address": "Avenida Gasteiz  66   ",
        "postalCode": "01008",
        "city": "1101059",
        "municipio": "Vitoria/Gasteiz",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.00",
        "surfaceTotal": "196.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "947fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1080.80",
        "askingPriceSale": "141855.00",
        "address": "Avenida Burjasot  91   ",
        "postalCode": "46009",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.64",
        "surfaceTotal": "196.64",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "967fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "1347.02",
        "askingPriceSale": "202053.60",
        "address": "Calle Escultor Luis Bolinches     ",
        "postalCode": "46023",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.36",
        "surfaceTotal": "160.36",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "987fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1997.10",
        "askingPriceSale": "310660.00",
        "address": "Calle Jaime Roig  26   ",
        "postalCode": "46010",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1036.00",
        "askingPriceSale": "161875.00",
        "address": "Avenida Juan XXIII  44   ",
        "postalCode": "46025",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.89",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.89",
        "surfaceTotal": "174.89",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2009.07",
        "askingPriceSale": "312522.00",
        "address": " Marques De Montortal  2   ",
        "postalCode": "46019",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "360.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "284.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "392.83",
        "surfaceTotal": "644.83",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2368.50",
        "askingPriceSale": "383180.00",
        "address": "Avenida Regne De Valencia  2   ",
        "postalCode": "46005",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "186.62",
        "surfaceMezzanine": "0.00",
        "surfacepb": "331.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "387.36",
        "surfaceTotal": "517.99",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Polvoranca  39   ",
        "postalCode": "28923",
        "city": "1128007",
        "municipio": "Alcorcon",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "170.75",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.19",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.42",
        "surfaceTotal": "320.94",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "856.80",
        "askingPriceSale": "128520.00",
        "address": "Calle Huelgas  10   ",
        "postalCode": "47005",
        "city": "1147186",
        "municipio": "Valladolid",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "141.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.22",
        "surfaceTotal": "141.22",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1212.12",
        "askingPriceSale": "158508.00",
        "address": "Avenida Zamora  23   ",
        "postalCode": "47008",
        "city": "1147186",
        "municipio": "Valladolid",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "133.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2028.60",
        "askingPriceSale": "260820.00",
        "address": "Calle Muelle De Portugal  21   ",
        "postalCode": "21400",
        "city": "1121010",
        "municipio": "Ayamonte",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.40",
        "surfaceTotal": "160.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1263.85",
        "askingPriceSale": "219800.00",
        "address": "Calle Dolores Ibarruri  4   ",
        "postalCode": "29700",
        "city": "1129094",
        "municipio": "Velez-Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "aa7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "1514.69",
        "askingPriceSale": "243667.20",
        "address": "Paseo Chapi  9   ",
        "postalCode": "03400",
        "city": "1103140",
        "municipio": "Villena",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "342.04",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.18",
        "surfaceBasement1": "175.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "175.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "470.29",
        "surfaceTotal": "797.22",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ac7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1684.20",
        "askingPriceSale": "224560.00",
        "address": "Calle Eras  17   ",
        "postalCode": "28670",
        "city": "1128181",
        "municipio": "Villaviciosa De Odon",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.66",
        "surfaceTotal": "264.66",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ae7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1218.00",
        "askingPriceSale": "162400.00",
        "address": "Calle Madrid  4   ",
        "postalCode": "28939",
        "city": "1110023",
        "municipio": "Arroyomolinos",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "852.04",
        "askingPriceSale": "125300.00",
        "address": "Calle La Haba  17   ",
        "postalCode": "06700",
        "city": "1106153",
        "municipio": "Villanueva De La Serena",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "402.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "402.28",
        "surfaceTotal": "402.28",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "797.58",
        "askingPriceSale": "110952.24",
        "address": "Calle Balbin Busto  20   ",
        "postalCode": "33300",
        "city": "1133076",
        "municipio": "Villaviciosa",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "75.70",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.27",
        "surfaceTotal": "194.26",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "395.53",
        "askingPriceSale": "56504.00",
        "address": "Plaza La Orden  26   ",
        "postalCode": "02480",
        "city": "1102086",
        "municipio": "Yeste",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1458.24",
        "askingPriceSale": "208320.00",
        "address": " Panchito Hernandez  8   ",
        "postalCode": "35400",
        "city": "1135006",
        "municipio": "Arucas",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.91",
        "surfaceTotal": "191.91",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1815.41",
        "askingPriceSale": "302568.00",
        "address": "Calle Orape Kalea  18   ",
        "postalCode": "20800",
        "city": "1120079",
        "municipio": "Zarautz",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.08",
        "surfaceTotal": "144.08",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ba7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "868.56",
        "askingPriceSale": "133056.00",
        "address": "Avenida De Cataluña  23   ",
        "postalCode": "50014",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "bc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1345.68",
        "askingPriceSale": "201852.00",
        "address": "Calle Pablo Ruiz Picasso  42   ",
        "postalCode": "50015",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.20",
        "surfaceTotal": "160.20",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "be7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4116.00",
        "askingPriceSale": "764400.00",
        "address": "Paseo Sagasta  80   ",
        "postalCode": "50006",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "322.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "322.00",
        "surfaceTotal": "322.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "915.60",
        "askingPriceSale": "122080.00",
        "address": "Calle Carretera de Coín  78   ",
        "postalCode": "29140",
        "city": "1129140",
        "municipio": "Churriana",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "89.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "89.00",
        "surfaceTotal": "89.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2407.99",
        "askingPriceSale": "339042.93",
        "address": "Calle Porto Colon  14   ",
        "postalCode": "28924",
        "city": "1128007",
        "municipio": "Alcorcon",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "261.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "261.00",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "address": "Avenida de los Descubrimientos  4   ",
        "postalCode": "41927",
        "city": "1141059",
        "municipio": "Mairena Del Aljarafe",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.50",
        "surfaceTotal": "111.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c67fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "askingPriceRent": "999.60",
        "askingPriceSale": "99960.00",
        "address": " Esteban Solis  13   ",
        "postalCode": "23250",
        "city": "1123079",
        "municipio": "Santisteban Del Puerto",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "113.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.50",
        "surfaceTotal": "238.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1262.66",
        "askingPriceSale": "174160.00",
        "address": "Calle Feria  2   ",
        "postalCode": "49005",
        "city": "1149275",
        "municipio": "Zamora",
        "province": "49",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "311.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "311.00",
        "surfaceTotal": "311.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ca7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1008.00",
        "askingPriceSale": "134400.00",
        "address": "Calle Valencia  1   ",
        "postalCode": "18100",
        "city": "1118021",
        "municipio": "Armilla",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.40",
        "surfaceTotal": "119.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "cc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1744.05",
        "askingPriceSale": "279048.00",
        "address": "Calle Mayor  9   ",
        "postalCode": "45500",
        "city": "1145173",
        "municipio": "Torrijos",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "442.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "442.00",
        "surfaceTotal": "442.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ce7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "431.20",
        "askingPriceSale": "49280.00",
        "address": "Calle San Pedro  35   ",
        "postalCode": "50800",
        "city": "1150298",
        "municipio": "Zuera",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.00",
        "surfaceTotal": "88.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1062.43",
        "askingPriceSale": "128520.00",
        "address": "Plaza Trafalgar  8   ",
        "postalCode": "08913",
        "city": "1108015",
        "municipio": "Badalona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "43.31",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.46",
        "surfaceTotal": "130.11",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "689.50",
        "askingPriceSale": "110320.00",
        "address": "Calle Iglesia  2   ",
        "postalCode": "23710",
        "city": "1123010",
        "municipio": "Bailen",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "42.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.60",
        "surfaceTotal": "211.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6442.51",
        "askingPriceSale": "787417.40",
        "address": "Calle Fueros  3   ",
        "postalCode": "48901",
        "city": "1148013",
        "municipio": "Barakaldo",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "355.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "475.79",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "582.35",
        "surfaceTotal": "830.99",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "764.40",
        "askingPriceSale": "141960.00",
        "address": "Calle Marcelino Suarez  2   ",
        "postalCode": "32314",
        "city": "1132009",
        "municipio": "O Barco De Valdeorras",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "140.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.47",
        "surfaceTotal": "276.78",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2967.30",
        "askingPriceSale": "538510.00",
        "address": "Paseo Bonanova  25   ",
        "postalCode": "08022",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "148.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.00",
        "surfaceTotal": "148.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "da7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1923.60",
        "askingPriceSale": "288540.00",
        "address": "Calle Via Medular  S/N   ",
        "postalCode": "35500",
        "city": "1135004",
        "municipio": "Arrecife",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "110.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.25",
        "surfaceTotal": "312.45",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "dc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "991.20",
        "askingPriceSale": "181720.00",
        "address": "Avenida Mare De Deu Montserrat  237   ",
        "postalCode": "08041",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.50",
        "surfaceTotal": "119.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "de7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6783.00",
        "askingPriceSale": "1492260.00",
        "address": "Avenida Marques De L'Argentera  3   ",
        "postalCode": "08003",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "323.34",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.67",
        "surfaceTotal": "323.34",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1974.00",
        "askingPriceSale": "375060.00",
        "address": "Avenida Republica Argentina  64   ",
        "postalCode": "08023",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "49.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.32",
        "surfaceTotal": "184.75",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1474.20",
        "askingPriceSale": "327600.00",
        "address": "Calle Santa Amelia  20   ",
        "postalCode": "08034",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "90.10",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.13",
        "surfaceTotal": "180.20",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3939.60",
        "askingPriceSale": "787920.00",
        "address": "Calle Sicilia  284   ",
        "postalCode": "08013",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "370.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "321.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "432.00",
        "surfaceTotal": "691.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1125.60",
        "askingPriceSale": "150080.00",
        "address": "Vía Julia  154 - 158   ",
        "postalCode": "08016",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.50",
        "surfaceTotal": "207.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Jose María Pereda  8   ",
        "postalCode": "28806",
        "city": "1128005",
        "municipio": "Alcala De Henares",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.00",
        "surfaceTotal": "153.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ea7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "891.80",
        "askingPriceSale": "137200.00",
        "address": "Calle Del Pla Dels Avellaners  8   ",
        "postalCode": "08210",
        "city": "1108252",
        "municipio": "Barbera Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "212.41",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.41",
        "surfaceTotal": "212.41",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ec7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "763.70",
        "askingPriceSale": "122192.00",
        "address": "Avenida Generalitat  68   ",
        "postalCode": "08210",
        "city": "1108252",
        "municipio": "Barbera Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "260.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "83.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.20",
        "surfaceTotal": "343.68",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ee7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "address": "Calle Alameda  11   ",
        "postalCode": "03501",
        "city": "1103031",
        "municipio": "Benidorm",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "244.01",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "323.30",
        "surfaceTotal": "494.11",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "f07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "700.00",
        "askingPriceSale": "98000.00",
        "address": "Paseo De Irizar  2   ",
        "postalCode": "20570",
        "city": "1120074",
        "municipio": "Bergara",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.00",
        "surfaceTotal": "162.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "f27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3990.00",
        "askingPriceSale": "714000.00",
        "address": "Calle Calixto Diez  3   ",
        "postalCode": "48012",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "369.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "369.00",
        "surfaceTotal": "369.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "f47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1253.11",
        "askingPriceSale": "156639.00",
        "address": " Sagarminaga - Archivo     ",
        "postalCode": "48001",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.67",
        "surfaceTotal": "221.67",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "f67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "840.00",
        "askingPriceSale": "126000.00",
        "address": "Calle San Esteban  9   ",
        "postalCode": "31010",
        "city": "1131901",
        "municipio": "Barañain",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "f87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "648.31",
        "askingPriceSale": "75636.40",
        "address": "Calle Cami Nou  95   ",
        "postalCode": "46910",
        "city": "1146054",
        "municipio": "Benetusser",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "154.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "fa7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "862.40",
        "askingPriceSale": "123970.00",
        "address": "Calle Mayor  1   ",
        "postalCode": "42300",
        "city": "1142043",
        "municipio": "Burgo De Osma-Ciudad De Osma",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "fc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "411.60",
        "askingPriceSale": "58800.00",
        "address": "Calle Justo Canton Salazar  13   ",
        "postalCode": "09240",
        "city": "1109056",
        "municipio": "Briviesca",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.00",
        "surfaceTotal": "84.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "fe7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1297.10",
        "askingPriceSale": "207536.00",
        "address": "Plaza Hnos.Gcia.Naveira  23   ",
        "postalCode": "15300",
        "city": "1115009",
        "municipio": "Betanzos",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "0080e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "address": "Avenida Reyes Catolicos  8   ",
        "postalCode": "09004",
        "city": "1109059",
        "municipio": "Burgos",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.62",
        "surfaceTotal": "220.62",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "0280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Conde Don Alonso,  38   ",
        "postalCode": "14280",
        "city": "1114008",
        "municipio": "Belalcazar",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "90.00",
        "surfaceTotal": "90.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "0480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida Jose Solis Ruiz  35   ",
        "postalCode": "14940",
        "city": "1114013",
        "municipio": "Cabra",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.00",
        "surfaceTotal": "149.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "58845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida Jose Solis Ruiz  35   ",
        "postalCode": "14940",
        "city": "1114013",
        "municipio": "Cabra",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.95",
        "surfaceBasement1": "74.95",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.95",
        "surfaceTotal": "74.95",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "62845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida Jose Solis Ruiz  35   ",
        "postalCode": "14940",
        "city": "1114013",
        "municipio": "Cabra",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "52.92",
        "surfaceBasement1": "52.92",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "52.92",
        "surfaceTotal": "52.92",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "64845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida Jose Solis Ruiz  35   ",
        "postalCode": "14940",
        "city": "1114013",
        "municipio": "Cabra",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "63.90",
        "surfaceBasement1": "63.90",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "63.90",
        "surfaceTotal": "63.90",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "66845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida Jose Solis Ruiz  35   ",
        "postalCode": "14940",
        "city": "1114013",
        "municipio": "Cabra",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "32.97",
        "surfaceBasement1": "32.97",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "32.97",
        "surfaceTotal": "32.97",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "0680e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "1554.00",
        "askingPriceSale": "238280.00",
        "address": "Avenida De Andalucia  41   ",
        "postalCode": "11007",
        "city": "1111012",
        "municipio": "Cadiz",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.65",
        "surfaceTotal": "179.65",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "0880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1612.80",
        "askingPriceSale": "241920.00",
        "address": "Plaza Juez Borrull  27   ",
        "postalCode": "12003",
        "city": "1112040",
        "municipio": "Castellon De La Plana/Castello",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.50",
        "surfaceTotal": "202.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "0a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "924.00",
        "askingPriceSale": "134400.00",
        "address": "Avenida Cantabria  23   ",
        "postalCode": "39400",
        "city": "1139025",
        "municipio": "Los Corrales De Buelna",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.20",
        "surfaceTotal": "140.20",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "0c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2245.60",
        "askingPriceSale": "308770.00",
        "address": "Calle Julian Ribera  15   ",
        "postalCode": "46740",
        "city": "1146083",
        "municipio": "Carcaixent",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "410.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "410.55",
        "surfaceTotal": "410.55",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "0e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "744.80",
        "askingPriceSale": "98000.00",
        "address": " Doctor Ferran  1   ",
        "postalCode": "08440",
        "city": "1108046",
        "municipio": "Cardedeu",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.23",
        "surfaceTotal": "112.23",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1974.00",
        "askingPriceSale": "263200.00",
        "address": "Calle Ronda Ramon Otero Pedrayo  5   ",
        "postalCode": "08860",
        "city": "1108056",
        "municipio": "Castelldefels",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "247.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "247.66",
        "surfaceTotal": "247.66",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "992.25",
        "askingPriceSale": "132300.00",
        "address": "Avenida Castelao  17   ",
        "postalCode": "15350",
        "city": "1115022",
        "municipio": "Cedeira",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.93",
        "surfaceTotal": "178.93",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1567.97",
        "askingPriceSale": "250474.00",
        "address": "Calle Monturiol  17   ",
        "postalCode": "43820",
        "city": "1143037",
        "municipio": "Calafell",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.91",
        "surfaceTotal": "178.91",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "693.00",
        "askingPriceSale": "77000.00",
        "address": " Reconquista  10   ",
        "postalCode": "33320",
        "city": "1133019",
        "municipio": "Colunga",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "83.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "83.00",
        "surfaceTotal": "83.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3094.00",
        "askingPriceSale": "452200.00",
        "address": "Calle Helsinki- Costa Adeje  SN   ",
        "postalCode": "38670",
        "city": "1138001",
        "municipio": "Adeje",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.58",
        "surfaceTotal": "169.58",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1540.00",
        "askingPriceSale": "224000.00",
        "address": "Calle Martires  20   ",
        "postalCode": "26500",
        "city": "1126036",
        "municipio": "Calahorra",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "149.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.70",
        "surfaceTotal": "298.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1097.46",
        "askingPriceSale": "154770.00",
        "address": "Calle Castillo  27   ",
        "postalCode": "13610",
        "city": "1113028",
        "municipio": "Campo De Criptana",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.72",
        "surfaceTotal": "178.72",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "1e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2076.90",
        "askingPriceSale": "276920.00",
        "address": "Avenida Costa Del Sol  1   ",
        "postalCode": "18690",
        "city": "1118017",
        "municipio": "Almuñecar",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "311.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "311.00",
        "surfaceTotal": "311.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "717.50",
        "askingPriceSale": "100450.00",
        "address": "Avenida De Las Negras  93   ",
        "postalCode": "04110",
        "city": "1104105",
        "municipio": "Campohermoso-Almeria",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "205.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.00",
        "surfaceTotal": "205.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2480e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "798.70",
        "askingPriceSale": "114100.00",
        "address": "Calle Major  10   ",
        "postalCode": "17244",
        "city": "1117044",
        "municipio": "Cassa De La Selva",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "70.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "70.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.95",
        "surfaceTotal": "275.30",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1982.40",
        "askingPriceSale": "231280.00",
        "address": "Calle Corredera  55   ",
        "postalCode": "11630",
        "city": "1111006",
        "municipio": "Arcos De La Frontera",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.00",
        "surfaceTotal": "227.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1486.80",
        "askingPriceSale": "220990.00",
        "address": "Avenida Reyes Catolicos  18   ",
        "postalCode": "16003",
        "city": "1116078",
        "municipio": "Cuenca",
        "province": "16",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.93",
        "surfaceTotal": "176.93",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1071.00",
        "askingPriceSale": "142800.00",
        "address": "Avenida San Pablo  26   ",
        "postalCode": "28823",
        "city": "1128049",
        "municipio": "Coslada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.28",
        "surfaceTotal": "157.28",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1680.00",
        "askingPriceSale": "268800.00",
        "address": "Carretera Malaga A Almeria, Termino De Enix     ",
        "postalCode": "04720",
        "city": "1104720",
        "municipio": "Aguadulce",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "192.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "192.00",
        "surfaceTotal": "192.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "2e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2688.00",
        "askingPriceSale": "402780.00",
        "address": " Familia Betancourt y Molina     ",
        "postalCode": "38400",
        "city": "1138028",
        "municipio": "Puerto De La Cruz",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "65.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "127.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.90",
        "surfaceTotal": "192.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "908.25",
        "askingPriceSale": "115045.00",
        "address": "Calle Corredera  11   ",
        "postalCode": "41600",
        "city": "1141011",
        "municipio": "Arahal",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.14",
        "surfaceTotal": "160.14",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2604.00",
        "askingPriceSale": "403200.00",
        "address": "Avenida Zumalacarregui  9   ",
        "postalCode": "20008",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "26.00",
        "surfacepb": "144.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "26.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.71",
        "surfaceTotal": "170.71",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "672.59",
        "askingPriceSale": "89678.40",
        "address": "Calle Ilicitano Ausente  19   ",
        "postalCode": "03202",
        "city": "1103065",
        "municipio": "Elche/Elx",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "128.11",
        "surfaceTotal": "128.11",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "692.58",
        "askingPriceSale": "92344.00",
        "address": "Calle Olegario Domarco Seller  73   ",
        "postalCode": "03206",
        "city": "1103065",
        "municipio": "Elche/Elx",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.90",
        "surfaceTotal": "164.90",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1587.60",
        "askingPriceSale": "212912.00",
        "address": "Calle Dahellos  9   ",
        "postalCode": "03600",
        "city": "1103066",
        "municipio": "Elda",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "303.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "267.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "357.90",
        "surfaceTotal": "570.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "806.17",
        "askingPriceSale": "136794.00",
        "address": "Calle Trencall  38   ",
        "postalCode": "46540",
        "city": "1146204",
        "municipio": "Puig",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.28",
        "surfaceTotal": "130.28",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "607.32",
        "askingPriceSale": "84350.00",
        "address": "Paseo de Andalucia  41   ",
        "postalCode": "14830",
        "city": "1114025",
        "municipio": "Espejo",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "226.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.00",
        "surfaceTotal": "226.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "3e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "885.50",
        "askingPriceSale": "112700.00",
        "address": "Calle Castelao  2   ",
        "postalCode": "29004",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1234.24",
        "askingPriceSale": "152306.00",
        "address": "Calle Marques De Valdespina  14   ",
        "postalCode": "48260",
        "city": "1148034",
        "municipio": "Ermua",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "116.74",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.76",
        "surfaceTotal": "233.48",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "askingPriceRent": "3018.40",
        "askingPriceSale": "473378.30",
        "address": "Calle Baja Navarra  1   ",
        "postalCode": "31200",
        "city": "1131097",
        "municipio": "Estella",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "121.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "223.30",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1940.40",
        "askingPriceSale": "344960.00",
        "address": "Calle Cruz De Luisa  11   ",
        "postalCode": "28945",
        "city": "1128058",
        "municipio": "Fuenlabrada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1270.22",
        "askingPriceSale": "200872.00",
        "address": "Avenida de Capuchinos  68   ",
        "postalCode": "29014",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.00",
        "surfaceTotal": "176.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1050.00",
        "askingPriceSale": "126000.00",
        "address": "Avenida Marques De Figueroa  4   ",
        "postalCode": "15500",
        "city": "1115035",
        "municipio": "Fene",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.97",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.97",
        "surfaceTotal": "149.97",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4405.59",
        "askingPriceSale": "656194.00",
        "address": "Calle Rutlla  19   ",
        "postalCode": "17600",
        "city": "1117066",
        "municipio": "Figueres",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "248.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "223.00",
        "surfaceBasement1": "104.90",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.90",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "248.80",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "350.09",
        "surfaceTotal": "576.70",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1365.00",
        "askingPriceSale": "273000.00",
        "address": " Plaza  11   ",
        "postalCode": "07200",
        "city": "1107022",
        "municipio": "Felanitx",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.00",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "4e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "10934.00",
        "askingPriceSale": "875770.00",
        "address": "Calle Rubalcava  12   ",
        "postalCode": "15402",
        "city": "1115036",
        "municipio": "Ferrol",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "205.76",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.00",
        "surfaceBasement1": "194.77",
        "surfaceBasement2": "176.69",
        "surfaceRest": "128.70",
        "surfacesr": "500.16",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "504.81",
        "surfaceTotal": "898.92",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5080e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "address": "Calle Comunidad De Madrid  2   ",
        "postalCode": "28597",
        "city": "1128060",
        "municipio": "Fuentidueña De Tajo",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "999.60",
        "askingPriceSale": "152880.00",
        "address": "Paseo Germanias  83   ",
        "postalCode": "46702",
        "city": "1146131",
        "municipio": "Gandia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.30",
        "surfaceTotal": "151.30",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "656.60",
        "askingPriceSale": "93800.00",
        "address": "Calle Mayor  26   ",
        "postalCode": "03140",
        "city": "1103076",
        "municipio": "Guardamar Del Segura",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.00",
        "surfaceTotal": "134.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "720.72",
        "askingPriceSale": "85176.00",
        "address": "Plaza Mayor  56   ",
        "postalCode": "46610",
        "city": "1146139",
        "municipio": "Guadassuar",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "8752.80",
        "askingPriceSale": "1750000.29",
        "address": "Plaza Porxada  30   ",
        "postalCode": "08400",
        "city": "1108096",
        "municipio": "Granollers",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "302.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "381.73",
        "surfaceBasement1": "217.73",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "217.73",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "302.68",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "581.40",
        "surfaceTotal": "902.14",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2584.05",
        "askingPriceSale": "381990.00",
        "address": "Calle Heroe De Sostoa  148   ",
        "postalCode": "29003",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "313.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "313.00",
        "surfaceTotal": "313.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1871.80",
        "askingPriceSale": "267400.00",
        "address": "Avenida De La Costa  147   ",
        "postalCode": "33203",
        "city": "1133024",
        "municipio": "Gijon",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "261.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "261.00",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "5e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "329280.00",
        "address": "Calle Torre Comares  S/N   ",
        "postalCode": "18008",
        "city": "1118087",
        "municipio": "Granada",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "336.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "336.00",
        "surfaceTotal": "336.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1380.12",
        "askingPriceSale": "211470.00",
        "address": "Avenida De España  37   ",
        "postalCode": "28903",
        "city": "1128065",
        "municipio": "Getafe",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "203.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.90",
        "surfaceTotal": "362.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1413.24",
        "askingPriceSale": "232769.60",
        "address": "Calle Pablo Picasso  11   ",
        "postalCode": "48300",
        "city": "1148046",
        "municipio": "Gernika-Lumo",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.76",
        "surfaceTotal": "118.76",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "847.00",
        "askingPriceSale": "135520.00",
        "address": "Calle Arrabal  4   ",
        "postalCode": "26200",
        "city": "1126071",
        "municipio": "Haro",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2240.00",
        "askingPriceSale": "403200.00",
        "address": "Calle Pedraforca  77   ",
        "postalCode": "08905",
        "city": "1108101",
        "municipio": "L'Hospitalet De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "107.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "347.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "107.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "379.10",
        "surfaceTotal": "454.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Los Olivos  29   ",
        "postalCode": "22005",
        "city": "1122125",
        "municipio": "Huesca",
        "province": "22",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.00",
        "surfaceTotal": "231.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1291.50",
        "askingPriceSale": "200900.00",
        "address": "Paseo Independencia  53   ",
        "postalCode": "21002",
        "city": "1121041",
        "municipio": "Huelva",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "206.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "206.00",
        "surfaceTotal": "206.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4209.62",
        "askingPriceSale": "693350.00",
        "address": "Paseo De Colon  27   ",
        "postalCode": "20302",
        "city": "1120045",
        "municipio": "Irun",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "197.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.10",
        "surfaceTotal": "353.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "6e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1716.18",
        "askingPriceSale": "208392.80",
        "address": "Plaza Cortes De Aragon  6   ",
        "postalCode": "22700",
        "city": "1122130",
        "municipio": "Jaca",
        "province": "22",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "49.22",
        "surfacepb": "133.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "49.22",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.76",
        "surfaceTotal": "182.37",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1192.10",
        "askingPriceSale": "201740.00",
        "address": "Calle Paraiso Nº 4. Edificio Jerez  74   ",
        "postalCode": "11405",
        "city": "1111020",
        "municipio": "Jerez De La Frontera",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Plaza Joaquina De Orea  2   ",
        "city": "1128035",
        "municipio": "Carabaña",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "50.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "60.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "80.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1675.80",
        "askingPriceSale": "274624.88",
        "address": "Calle Alcalde Perez Arda  26   ",
        "postalCode": "15008",
        "city": "1115030",
        "municipio": "A Coruña",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4198.95",
        "askingPriceSale": "671832.00",
        "address": "Cuesta La Palloza  1   ",
        "postalCode": "15006",
        "city": "1115030",
        "municipio": "A Coruña",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "304.78",
        "surfaceBasement1": "101.70",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "101.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "355.63",
        "surfaceTotal": "406.48",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2079.00",
        "askingPriceSale": "399486.40",
        "address": "Avenida General Sanjurjo  121   ",
        "postalCode": "15006",
        "city": "1115030",
        "municipio": "A Coruña",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.00",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceSale": "90860.00",
        "address": "Calle Vizcaya  1   ",
        "postalCode": "15007",
        "city": "1115030",
        "municipio": "A Coruña",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "101.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "101.00",
        "surfaceTotal": "101.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "739.20",
        "askingPriceSale": "97440.00",
        "address": "Calle Antonio Muñoz Zamora  2   ",
        "postalCode": "04007",
        "city": "1104013",
        "municipio": "Almeria",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.00",
        "surfaceTotal": "94.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "7e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1001.00",
        "askingPriceSale": "160160.00",
        "address": "Avenida De Los Reyes Leoneses  12   ",
        "postalCode": "24008",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "69.79",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.82",
        "surfaceTotal": "205.67",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1209.85",
        "askingPriceSale": "201642.00",
        "address": "Calle El Sabinar  6   ",
        "postalCode": "24007",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "288.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "288.00",
        "surfaceTotal": "288.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "967.68",
        "askingPriceSale": "135475.20",
        "address": "Calle General Gutierrez Mellado  28   ",
        "postalCode": "24010",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.24",
        "surfaceTotal": "138.24",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1743.00",
        "askingPriceSale": "255640.00",
        "address": "Calle Velazquez  18   ",
        "postalCode": "24005",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.40",
        "surfaceTotal": "166.40",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1310.40",
        "askingPriceSale": "262080.00",
        "address": "Calle Lardero  18   ",
        "postalCode": "26002",
        "city": "1126089",
        "municipio": "Logroño",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.78",
        "surfaceTotal": "144.78",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2394.00",
        "askingPriceSale": "399000.00",
        "address": "Calle Corredera De San Marcos  45   ",
        "postalCode": "23700",
        "city": "1123055",
        "municipio": "Linares",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "135.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "341.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "381.50",
        "surfaceTotal": "476.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "785.51",
        "askingPriceSale": "117826.80",
        "address": "Plaza De La Victoria,  1   ",
        "postalCode": "18300",
        "city": "1118122",
        "municipio": "Loja",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.54",
        "surfaceTotal": "280.54",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Major  1   ",
        "postalCode": "17490",
        "city": "1117092",
        "municipio": "Llanca",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "68.00",
        "surfaceTotal": "68.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "8e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5929.00",
        "askingPriceSale": "974050.00",
        "address": "Avenida Francesc Macia  37   ",
        "postalCode": "25007",
        "city": "1125120",
        "municipio": "Lleida",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "313.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "283.62",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "455.58",
        "surfaceTotal": "597.39",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2244.20",
        "askingPriceSale": "304570.00",
        "address": "Calle Roma Barnes  12   ",
        "postalCode": "17310",
        "city": "1117095",
        "municipio": "Lloret De Mar",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "229.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "229.00",
        "surfaceTotal": "229.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1416.10",
        "askingPriceSale": "254560.50",
        "address": "Calle Martin Iriarte  9   ",
        "postalCode": "28290",
        "city": "1128127",
        "municipio": "Las Rozas",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "122.00",
        "surfaceTotal": "122.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1890.00",
        "askingPriceSale": "283500.00",
        "address": "Plaza de Espronceda  8   ",
        "postalCode": "06200",
        "city": "1106011",
        "municipio": "Almendralejo",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "138.55",
        "surfaceMezzanine": "0.00",
        "surfacepb": "268.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "310.33",
        "surfaceTotal": "407.31",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1609.78",
        "askingPriceSale": "241466.40",
        "address": "Avenida Juan XXIII  11   ",
        "postalCode": "35004",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.64",
        "surfaceTotal": "161.64",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2772.00",
        "askingPriceSale": "262808.00",
        "address": "Avenida Pintor Felo Monzon  27   ",
        "postalCode": "35019",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "86.75",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.22",
        "surfaceTotal": "211.96",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2030.00",
        "askingPriceSale": "284200.00",
        "address": "Calle Ollerias  49   ",
        "postalCode": "23740",
        "city": "1123005",
        "municipio": "Andujar",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "42.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "277.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "289.76",
        "surfaceTotal": "319.31",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "575.40",
        "askingPriceSale": "89187.00",
        "address": "Calle Real  7   ",
        "postalCode": "23200",
        "city": "1123024",
        "municipio": "La Carolina",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "9e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1092.00",
        "askingPriceSale": "145600.00",
        "address": " La Luz  4   ",
        "postalCode": "30710",
        "city": "1130902",
        "municipio": "Los Alcazares",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.38",
        "surfaceTotal": "152.38",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1608.60",
        "askingPriceSale": "174265.00",
        "address": "Paseo Del Pilarin  1   ",
        "postalCode": "33700",
        "city": "1133700",
        "municipio": "Luarca",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.50",
        "surfaceTotal": "191.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "901.60",
        "askingPriceSale": "130732.00",
        "address": "Calle Colon  2   ",
        "postalCode": "41440",
        "city": "1141055",
        "municipio": "Lora Del Rio",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "199.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.60",
        "surfaceTotal": "199.60",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2030.00",
        "askingPriceSale": "253750.00",
        "address": "Avenida Alameda Del Valle  34   ",
        "district": "2807913",
        "postalCode": "28051",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "139.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "139.00",
        "surfaceTotal": "139.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1480.19",
        "askingPriceSale": "222028.80",
        "address": "Calle Alamos  5   ",
        "postalCode": "23680",
        "city": "1123002",
        "municipio": "Alcala La Real",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.00",
        "surfaceTotal": "264.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "a880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "3724.00",
        "askingPriceSale": "588000.00",
        "address": " Bravo Murillo  307   ",
        "district": "2807906",
        "postalCode": "28020",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "36.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.43",
        "surfaceTotal": "230.90",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "aa80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6804.00",
        "askingPriceSale": "1134000.00",
        "address": " Bravo Murillo  211   ",
        "district": "2807906",
        "postalCode": "28020",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "164.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "164.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "240.20",
        "surfaceTotal": "355.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ac80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "22540.00",
        "askingPriceSale": "6223000.00",
        "address": "Avenida De Felipe II  16   ",
        "district": "2807903",
        "postalCode": "28009",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "420.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "344.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "420.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "470.00",
        "surfaceTotal": "764.00",
        "agent": "Vicente Sánchez Molina",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ae80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "529.20",
        "askingPriceSale": "74970.00",
        "address": "Carretera De Jaen  50   ",
        "postalCode": "02006",
        "city": "1102003",
        "municipio": "Albacete",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6339.20",
        "askingPriceSale": "1030120.00",
        "address": "Paseo Del Molino  2   ",
        "postalCode": "28045",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "284.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "284.00",
        "surfaceTotal": "284.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "9632.00",
        "askingPriceSale": "2022720.00",
        "address": "Calle Diego De Leon  54   ",
        "postalCode": "28006",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "450.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "450.00",
        "surfaceTotal": "450.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3645.60",
        "askingPriceSale": "668360.00",
        "address": "Calle Emilio Ferrari  24   ",
        "district": "2807920",
        "postalCode": "28017",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "37.00",
        "surfacepb": "184.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "37.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.50",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1582.00",
        "askingPriceSale": "261030.00",
        "address": "Calle Esteban Mora  43   ",
        "district": "2807915",
        "postalCode": "28027",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.05",
        "surfaceTotal": "113.05",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "b880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2793.00",
        "askingPriceSale": "489990.69",
        "address": "Calle Estrella Polar  5   ",
        "postalCode": "28007",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.65",
        "surfaceTotal": "130.65",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ba80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1733.13",
        "askingPriceSale": "269598.00",
        "address": "Carretera De Madrid  11   ",
        "postalCode": "02006",
        "city": "1102003",
        "municipio": "Albacete",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "275.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "275.10",
        "surfaceTotal": "275.10",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "bc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "3530.80",
        "askingPriceSale": "651840.00",
        "address": "Calle Eugenio Salazar  20   ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "No",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.55",
        "surfaceTotal": "194.55",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "be80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceSale": "723996.00",
        "address": " Ps Extremadura  57   ",
        "district": "2807909",
        "postalCode": "28011",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "212.30",
        "surfaceBasement1": "75.20",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "94.63",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.62",
        "surfaceTotal": "306.93",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5250.00",
        "askingPriceSale": "945000.00",
        "address": " Francisco Silvela  53   ",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "167.65",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.13",
        "surfaceTotal": "354.48",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "2956.80",
        "askingPriceSale": "564480.00",
        "address": "Calle Galileo  57   ",
        "district": "2807907",
        "postalCode": "28015",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.14",
        "surfaceTotal": "191.14",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1592.50",
        "askingPriceSale": "250250.00",
        "address": "Calle General Ricardos  183   ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.50",
        "surfaceTotal": "162.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2217.60",
        "askingPriceSale": "291060.00",
        "address": "Calle Halcon  2   ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.35",
        "surfaceTotal": "198.35",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "c880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1540.00",
        "askingPriceSale": "246400.00",
        "address": "Calle Perez Galdos  25   ",
        "postalCode": "02003",
        "city": "1102003",
        "municipio": "Albacete",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "201.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.32",
        "surfaceTotal": "201.32",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ca80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2344.41",
        "askingPriceSale": "309605.21",
        "address": "Calle Jose Del Hierro  46   ",
        "postalCode": "28027",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "177.00",
        "surfaceTotal": "177.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "cc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "7000.00",
        "askingPriceSale": "1286562.10",
        "address": "Paseo Almeria  52   ",
        "postalCode": "04001",
        "city": "1104013",
        "municipio": "Almeria",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "217.14",
        "surfaceTotal": "217.14",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ce80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "11165.00",
        "askingPriceSale": "2256659.31",
        "address": "Plaza Magdalena  9   ",
        "postalCode": "41001",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "465.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "365.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "504.50",
        "surfaceTotal": "830.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6330.80",
        "askingPriceSale": "1020874.41",
        "address": " Doctor Esquerdo  197   ",
        "postalCode": "28007",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "173.60",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.68",
        "surfaceTotal": "347.20",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "371.52",
        "askingPriceSale": "54040.00",
        "address": "Calle Cervantes  4   ",
        "postalCode": "41590",
        "city": "1141082",
        "municipio": "La Roda De Andalucia",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.50",
        "surfaceTotal": "96.50",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1741.32",
        "askingPriceSale": "306162.47",
        "address": "Calle Añastro  9   ",
        "postalCode": "28033",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "26.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "62.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "70.19",
        "surfaceTotal": "89.03",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "212.80",
        "askingPriceSale": "26600.00",
        "address": "Calle Salvador  1   ",
        "postalCode": "06713",
        "city": "1106001",
        "municipio": "Acedera",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "d880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "434.70",
        "askingPriceSale": "59570.00",
        "address": "Calle Manuel Lodares  5   ",
        "postalCode": "02639",
        "city": "1102015",
        "municipio": "Barrax",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.34",
        "surfaceTotal": "115.34",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "da80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "463.04",
        "askingPriceSale": "67351.20",
        "address": " Santa Isabel  2   ",
        "postalCode": "26002",
        "city": "1126005",
        "municipio": "Albelda De Iregua",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "dc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "725.69",
        "askingPriceSale": "64793.75",
        "address": "Calle La Botica     ",
        "postalCode": "33790",
        "city": "1133041",
        "municipio": "Navia",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.05",
        "surfaceTotal": "74.05",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "de80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5264.00",
        "askingPriceSale": "1184400.00",
        "address": "Calle Principe de Vergara  206   ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "235.85",
        "surfaceMezzanine": "0.00",
        "surfacepb": "51.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.76",
        "surfaceTotal": "286.85",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "465.50",
        "askingPriceSale": "55860.00",
        "address": " Mayor     ",
        "postalCode": "37730",
        "city": "1137171",
        "municipio": "Ledrada",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.00",
        "surfaceTotal": "126.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "605.22",
        "askingPriceSale": "102784.90",
        "address": "Calle Les Voltes  15-17   ",
        "postalCode": "17100",
        "city": "1117022",
        "municipio": "La Bisbal Demporda",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "77.71",
        "surfacepb": "92.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "77.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.11",
        "surfaceTotal": "169.96",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1064.63",
        "askingPriceSale": "177438.80",
        "address": "Carretera Malgrat  3   ",
        "postalCode": "17300",
        "city": "1117023",
        "municipio": "Blanes",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.06",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.06",
        "surfaceTotal": "181.06",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2576.00",
        "askingPriceSale": "274204.73",
        "address": "Avenida Marítima  37   ",
        "postalCode": "38040",
        "city": "1138040",
        "municipio": "Santiago Del Teide",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "e880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1383.20",
        "askingPriceSale": "191520.00",
        "address": "Calle Mago De Oz  7   ",
        "postalCode": "19005",
        "city": "1119130",
        "municipio": "Guadalajara",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.00",
        "surfaceTotal": "152.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ea80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5594.40",
        "askingPriceSale": "932400.00",
        "address": " General Vives  55 - 57   ",
        "postalCode": "35007",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "240.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "444.00",
        "surfaceTotal": "564.00",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ec80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "768.32",
        "askingPriceSale": "80388.00",
        "address": "Carretera Nou  24   ",
        "postalCode": "46670",
        "city": "1146203",
        "municipio": "La Pobla Llarga",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.17",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "168.36",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.35",
        "surfaceTotal": "343.53",
        "timeAvailableFrom": "9/13/22 13:23"
    },
    {
        "id": "ee80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1008.00",
        "askingPriceSale": "100800.00",
        "address": " Mayor  25   ",
        "postalCode": "47320",
        "city": "1147175",
        "municipio": "Tudela De Duero",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "139.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "211.70",
        "surfaceTotal": "309.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2492.00",
        "askingPriceSale": "352156.00",
        "address": "Avenida De Madrid  16   ",
        "postalCode": "32630",
        "city": "1132032",
        "municipio": "Xinzo De Limia",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "101.41",
        "surfacepb": "137.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "101.41",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.06",
        "surfaceTotal": "238.76",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "360.57",
        "askingPriceSale": "49490.00",
        "address": "Plaza De La Constitucion  7   ",
        "postalCode": "14620",
        "city": "1114018",
        "municipio": "El Carpio",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "82.68",
        "surfaceTotal": "82.68",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "431.20",
        "askingPriceSale": "55440.00",
        "address": " Alamillo  18   ",
        "postalCode": "28360",
        "city": "1128170",
        "municipio": "Villaconejos",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "77.02",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "77.02",
        "surfaceTotal": "77.02",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "558.60",
        "askingPriceSale": "134064.00",
        "address": " Alejandro Soler  2   ",
        "postalCode": "46003",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "327.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "327.00",
        "surfaceTotal": "327.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1120.00",
        "askingPriceSale": "168000.00",
        "address": " Veinte  74   ",
        "postalCode": "43100",
        "city": "1143148",
        "municipio": "Tarragona",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.50",
        "surfaceTotal": "166.50",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "fa80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "342.22",
        "askingPriceSale": "44100.00",
        "address": " Torogil  5   ",
        "postalCode": "34309",
        "city": "1134055",
        "municipio": "Cervatos De La Cueza",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "61.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "61.20",
        "surfaceTotal": "61.20",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "fc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "952.00",
        "askingPriceSale": "133280.00",
        "address": " Major  72   ",
        "postalCode": "08970",
        "city": "1108217",
        "municipio": "Sant Joan Despi",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "fe80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "787.50",
        "askingPriceSale": "113750.00",
        "address": " Progreso-Portonovo  53   ",
        "postalCode": "36970",
        "city": "1136051",
        "municipio": "Sanxenxo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "582.60",
        "askingPriceSale": "82222.00",
        "address": " Real  206   ",
        "postalCode": "18240",
        "city": "1118158",
        "municipio": "Pinos-Puente",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.00",
        "surfaceTotal": "124.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1486.68",
        "askingPriceSale": "202312.17",
        "address": "Vía Carpetana  81   ",
        "district": "2807911",
        "postalCode": "28047",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "81.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "122.60",
        "surfaceTotal": "179.30",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "809.45",
        "askingPriceSale": "120291.11",
        "address": " Paseo De Los Castellanos, 65  65   ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "90.38",
        "surfaceTotal": "90.38",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1659.00",
        "askingPriceSale": "337981.69",
        "address": " Oña  69   ",
        "postalCode": "28050",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "139.23",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.49",
        "surfaceTotal": "257.95",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "4992.96",
        "askingPriceSale": "748944.00",
        "address": "Avenida Betanzos  72-74   ",
        "district": "2807908",
        "postalCode": "28034",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "258.86",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "148.94",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "315.33",
        "surfaceTotal": "571.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "614.60",
        "askingPriceSale": "98336.00",
        "address": "Travesía De Vigo  99   ",
        "postalCode": "36207",
        "city": "1136057",
        "municipio": "Vigo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "104.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "66.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "97.46",
        "surfaceTotal": "170.40",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1060.37",
        "askingPriceSale": "123710.30",
        "address": " Corredera  53   ",
        "postalCode": "41520",
        "city": "1141102",
        "municipio": "El Viso Del Alcor",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "112.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "56.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "431.20",
        "askingPriceSale": "53900.00",
        "address": " Corredera  24   ",
        "postalCode": "14270",
        "city": "1114035",
        "municipio": "Hinojosa Del Duque",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1081e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "835.27",
        "askingPriceSale": "134686.60",
        "address": " Comandante Fortea  32   ",
        "postalCode": "28008",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.00",
        "surfaceTotal": "113.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1156.40",
        "askingPriceSale": "132160.00",
        "address": "Avenida Constitucion  16   ",
        "postalCode": "33678",
        "city": "1133002",
        "municipio": "Aller",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "234.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.00",
        "surfaceTotal": "234.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4704.00",
        "askingPriceSale": "806400.00",
        "address": "Plaza Luca De Tena  7   ",
        "district": "2807902",
        "postalCode": "28045",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "398.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "491.43",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "610.83",
        "surfaceTotal": "889.43",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "3724.00",
        "askingPriceSale": "425600.00",
        "address": "Calle Alqueria  10   ",
        "postalCode": "46469",
        "city": "1146065",
        "municipio": "Beniparrell",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Nave industrial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1843.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1843.00",
        "surfaceTotal": "1843.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4831.18",
        "askingPriceSale": "644156.80",
        "address": " Salvador Manrique De Lara  S/N   ",
        "postalCode": "35010",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1123.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1123.22",
        "surfaceTotal": "1123.22",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "430.71",
        "askingPriceSale": "57428.00",
        "address": "Plaza Constitución  2   ",
        "postalCode": "31252",
        "city": "1131053",
        "municipio": "Berbinzana",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.00",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1c81e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "672.00",
        "askingPriceSale": "94080.00",
        "address": "Avenida De Barcelona  42   ",
        "postalCode": "29009",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "59.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "59.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "59.00",
        "surfaceTotal": "59.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "957.60",
        "askingPriceSale": "167580.00",
        "address": "Calle Santa Fe  4   ",
        "postalCode": "45001",
        "city": "1145168",
        "municipio": "Toledo",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.00",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1684.48",
        "askingPriceSale": "258048.00",
        "address": " Conjunto Playa Virginia  7   ",
        "postalCode": "29018",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.51",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.51",
        "surfaceTotal": "255.51",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2281e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "2195.18",
        "askingPriceSale": "322872.23",
        "address": " Polig. Ind. Valle De Güimar     ",
        "postalCode": "38500",
        "city": "1138011",
        "municipio": "Candelaria",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "56.00",
        "surfacepb": "405.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "56.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "433.00",
        "surfaceTotal": "461.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1134.00",
        "askingPriceSale": "158760.00",
        "address": "Paseo De Olot  s/n   ",
        "postalCode": "17005",
        "city": "1117079",
        "municipio": "Girona",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.81",
        "surfaceTotal": "161.81",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2798.57",
        "askingPriceSale": "388080.00",
        "address": " Aragon  127   ",
        "postalCode": "07005",
        "city": "1107040",
        "municipio": "Palma De Mallorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "107.74",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.74",
        "surfaceTotal": "233.16",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "500.50",
        "askingPriceSale": "84700.00",
        "address": " Cola Y Goiti  9   ",
        "postalCode": "01003",
        "city": "1101059",
        "municipio": "Vitoria/Gasteiz",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "566.54",
        "askingPriceSale": "79316.30",
        "address": "Calle Real  103-105   ",
        "postalCode": "18240",
        "city": "1118158",
        "municipio": "Pinos-Puente",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.00",
        "surfaceTotal": "162.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "340.27",
        "askingPriceSale": "49123.71",
        "address": "Carretera De Almarza  1   ",
        "postalCode": "24880",
        "city": "1124183",
        "municipio": "Valderrueda",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.72",
        "surfaceTotal": "116.72",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "4057.20",
        "askingPriceSale": "939801.36",
        "address": " Eustasio Amilibia  10   ",
        "postalCode": "20011",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "6081.88",
        "askingPriceSale": "1681555.74",
        "address": " San Francisco  25   ",
        "postalCode": "20001",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "329.28",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.89",
        "surfaceTotal": "449.39",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Pendiente validación técnica",
        "strategy": "ALQUILER",
        "askingPriceRent": "1155.42",
        "askingPriceSale": "177941.64",
        "address": "Calle Figuera Major,  45   ",
        "postalCode": "08304",
        "city": "1108121",
        "municipio": "Mataro",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.00",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1064.00",
        "askingPriceSale": "148960.00",
        "address": "Avenida Constitucion  207   ",
        "postalCode": "28850",
        "city": "1128148",
        "municipio": "Torrejon De Ardoz",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1489.60",
        "askingPriceSale": "211680.00",
        "address": "Avenida De La Industria  18   ",
        "postalCode": "28947",
        "city": "1128058",
        "municipio": "Fuenlabrada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "217.00",
        "surfaceTotal": "217.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "808.50",
        "askingPriceSale": "115500.00",
        "address": "Paseo Santa Lucia  103   ",
        "postalCode": "31012",
        "city": "1131201",
        "municipio": "Pamplona/Iruña",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.00",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "901.60",
        "askingPriceSale": "103040.00",
        "address": "Avenida Borbon  70   ",
        "postalCode": "08003",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "99.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "99.18",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.97",
        "surfaceTotal": "173.40",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1711.64",
        "askingPriceSale": "256746.00",
        "address": "Carretera De Matadepera  195-203   ",
        "postalCode": "08225",
        "city": "1108279",
        "municipio": "Terrassa",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "305.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "305.65",
        "surfaceTotal": "305.65",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "331.10",
        "askingPriceSale": "42140.00",
        "address": "Avenida Valencia  12   ",
        "postalCode": "46294",
        "city": "1146084",
        "municipio": "Carcer",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1423.52",
        "askingPriceSale": "222425.00",
        "address": " La Legion  6-8   ",
        "postalCode": "52001",
        "city": "1152001",
        "municipio": "Melilla",
        "province": "52",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.04",
        "surfaceTotal": "134.04",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1165.50",
        "askingPriceSale": "155400.00",
        "address": "Calle Jacinto Verdaguer  32   ",
        "postalCode": "08397",
        "city": "1108163",
        "municipio": "Pineda De Mar",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "110.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "210.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "770.00",
        "askingPriceSale": "115500.00",
        "address": "Calle Olivo  4   ",
        "postalCode": "28970",
        "city": "1119151",
        "municipio": "Humanes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.48",
        "surfaceTotal": "99.48",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "483.00",
        "askingPriceSale": "56350.00",
        "address": "Calle Juan Jose Espejo  37   ",
        "postalCode": "14910",
        "city": "1114010",
        "municipio": "Benameji",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "798.00",
        "askingPriceSale": "133000.00",
        "address": "Calle Mestre Falla  5   ",
        "postalCode": "08850",
        "city": "1108089",
        "municipio": "Gava",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "95.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "95.00",
        "surfaceTotal": "95.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "480.20",
        "askingPriceSale": "54880.00",
        "address": "Calle Iglesias  10   ",
        "postalCode": "14470",
        "city": "1114074",
        "municipio": "El Viso",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "102.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "102.00",
        "surfaceTotal": "102.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1098.13",
        "askingPriceSale": "146417.60",
        "address": "Paseo De La Rosaleda     ",
        "postalCode": "24400",
        "city": "1124115",
        "municipio": "Ponferrada",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "247.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "236.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "310.95",
        "surfaceTotal": "484.16",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "askingPriceRent": "1075.20",
        "askingPriceSale": "161280.00",
        "address": "Calle Rambla de los Menceyes  14   ",
        "postalCode": "38530",
        "city": "1138011",
        "municipio": "Candelaria",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.40",
        "surfaceTotal": "120.40",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1393.70",
        "askingPriceSale": "276220.00",
        "address": "Avenida Carlos Iii,  45   ",
        "postalCode": "14014",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.24",
        "surfaceTotal": "166.24",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3960.81",
        "askingPriceSale": "660135.00",
        "address": "Calle General Concha  22   ",
        "postalCode": "48010",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.00",
        "surfaceTotal": "189.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "879.20",
        "askingPriceSale": "120890.00",
        "address": "Calle Joaquín Chapaprieta  148   ",
        "postalCode": "03183",
        "city": "1103133",
        "municipio": "Torrevieja",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1008.00",
        "askingPriceSale": "147840.00",
        "address": " Wisterra  6   ",
        "postalCode": "28232",
        "city": "1128127",
        "municipio": "Las Rozas",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.00",
        "surfaceTotal": "96.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1199.94",
        "askingPriceSale": "199990.00",
        "address": "Avenida Joan Prim  131-139   ",
        "postalCode": "08401",
        "city": "1108096",
        "municipio": "Granollers",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.00",
        "surfaceTotal": "134.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "4466.35",
        "askingPriceSale": "765660.00",
        "address": "Calle Travessera De Dalt  117-119   ",
        "postalCode": "08024",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "375.00",
        "surfaceBasement1": "161.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "161.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "455.50",
        "surfaceTotal": "536.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1101.10",
        "askingPriceSale": "150150.00",
        "address": "Calle Almeria  14   ",
        "postalCode": "29018",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.65",
        "surfaceTotal": "132.65",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1281.00",
        "askingPriceSale": "179340.00",
        "address": "Avenida Quevedo  33   ",
        "postalCode": "24009",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "182.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.98",
        "surfaceTotal": "182.98",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1792.00",
        "askingPriceSale": "313600.00",
        "address": "Calle Puente De La Reina     ",
        "postalCode": "28050",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.53",
        "surfaceTotal": "120.53",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1047.20",
        "askingPriceSale": "157080.00",
        "address": "Calle Bruguers  22   ",
        "postalCode": "08820",
        "city": "1108169",
        "municipio": "El Prat De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "676.20",
        "askingPriceSale": "91770.00",
        "address": "Calle Federico Garcia Lorca,  24   ",
        "postalCode": "08191",
        "city": "1108184",
        "municipio": "Rubi",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "133.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "860.04",
        "askingPriceSale": "138647.76",
        "address": "Avenida Barcelona  176   ",
        "postalCode": "08700",
        "city": "1108102",
        "municipio": "Igualada",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "293.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "293.00",
        "surfaceTotal": "293.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1117.41",
        "askingPriceSale": "131460.00",
        "address": "Calle Cataluña  1   ",
        "postalCode": "08740",
        "city": "1108196",
        "municipio": "Sant Andreu De La Barca",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "28.30",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "79.75",
        "surfaceTotal": "93.90",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1100.40",
        "askingPriceSale": "183400.00",
        "address": "Calle Calassanç Duran  12-18   ",
        "postalCode": "08203",
        "city": "1108187",
        "municipio": "Sabadell",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "78.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "52.48",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.71",
        "surfaceTotal": "130.95",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1575.00",
        "askingPriceSale": "231000.00",
        "address": "Carretera General Del Norte  63   ",
        "postalCode": "38350",
        "city": "1138043",
        "municipio": "Tacoronte",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "339.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "339.00",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1488.41",
        "askingPriceSale": "263914.00",
        "address": "Calle Minerva  15   ",
        "district": "2807919",
        "postalCode": "28032",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "66.62",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.03",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.02",
        "surfaceTotal": "134.65",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "940.80",
        "askingPriceSale": "156800.00",
        "address": "Avenida Argentina  2   ",
        "postalCode": "28918",
        "city": "1128074",
        "municipio": "Leganes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.50",
        "surfaceTotal": "112.50",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "873.60",
        "askingPriceSale": "145600.00",
        "address": "Calle Sant Boi De Llobregat  2   ",
        "postalCode": "08970",
        "city": "1108217",
        "municipio": "Sant Joan Despi",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.00",
        "surfaceTotal": "104.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1444.80",
        "askingPriceSale": "234780.00",
        "address": "Avenida Minero Hiribidea  42   ",
        "postalCode": "48500",
        "city": "1148002",
        "municipio": "Abanto Y Ciervana/Abanto Zierbena",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.00",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "749.70",
        "askingPriceSale": "83300.00",
        "address": "Paseo Buenavista  30   ",
        "postalCode": "12100",
        "city": "1112040",
        "municipio": "Castellon De La Plana/Castello",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1036.79",
        "askingPriceSale": "118490.40",
        "address": "Rua Das  Teixugueiras   ",
        "postalCode": "36212",
        "city": "1136057",
        "municipio": "Vigo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "212.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.00",
        "surfaceTotal": "212.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "7e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2732.80",
        "askingPriceSale": "307440.00",
        "address": "Calle Escultor Monjo  13-14-15   ",
        "postalCode": "08340",
        "city": "1108219",
        "municipio": "Vilassar De Mar",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.38",
        "surfaceTotal": "203.38",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "635.04",
        "askingPriceSale": "75600.00",
        "address": "Plaza De La Era  2   ",
        "postalCode": "08800",
        "city": "1108307",
        "municipio": "Vilanova I La Geltru",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.64",
        "surfaceTotal": "103.64",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1456.00",
        "askingPriceSale": "207416.26",
        "address": "Calle Alhambra     ",
        "postalCode": "03189",
        "city": "1103099",
        "municipio": "Orihuela",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "135.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.25",
        "surfaceTotal": "380.99",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "505.12",
        "askingPriceSale": "71176.00",
        "address": "Avenida De Los Emigrantes  9   ",
        "postalCode": "06474",
        "city": "1106138",
        "municipio": "Valdetorres",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.40",
        "surfaceTotal": "178.40",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceSale": "1503017.60",
        "address": "Carretera Dehesas A Fuenfria     ",
        "postalCode": "28470",
        "city": "1128038",
        "municipio": "Cercedilla",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Centro Formación",
        "smokeStractor": undefined,
        "surfacebr": "739.04",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "7418.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3930.76",
        "surfaceTotal": "8157.14",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "416.90",
        "askingPriceSale": "47865.86",
        "address": "Calle Hermanos Machado  21   ",
        "postalCode": "41860",
        "city": "1141045",
        "municipio": "Gerena",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3528.00",
        "askingPriceSale": "640919.84",
        "address": " Juan Carlos I  86   ",
        "postalCode": "28916",
        "city": "1128074",
        "municipio": "Leganes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.00",
        "surfaceTotal": "146.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4288.90",
        "askingPriceSale": "515200.00",
        "address": "Calle Mayor  2   ",
        "postalCode": "04620",
        "city": "1104100",
        "municipio": "Vera",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "86.56",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "409.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "360.17",
        "surfaceTotal": "625.46",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "8e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "745.50",
        "askingPriceSale": "104370.00",
        "address": "Calle San Benito  11   ",
        "postalCode": "29320",
        "city": "1129032",
        "municipio": "Campillos",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "66.02",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.79",
        "surfaceTotal": "259.80",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1072.96",
        "askingPriceSale": "160944.00",
        "address": "Calle Joaquin Chapaprieta  13   ",
        "postalCode": "03181",
        "city": "1103133",
        "municipio": "Torrevieja",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "152.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.79",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.59",
        "surfaceTotal": "298.47",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1057.00",
        "askingPriceSale": "147980.00",
        "address": "Calle Circunvalacion  6   ",
        "postalCode": "28850",
        "city": "1128148",
        "municipio": "Torrejon De Ardoz",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.00",
        "surfaceTotal": "151.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "551.46",
        "askingPriceSale": "82719.00",
        "address": "Calle Real  118   ",
        "postalCode": "13380",
        "city": "1113009",
        "municipio": "Aldea Del Rey",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "50.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "75.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.50",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Okupado",
        "strategy": "VENTA",
        "askingPriceRent": "1972.67",
        "askingPriceSale": "290843.78",
        "address": "Calle Zurbarán  4   ",
        "postalCode": "45511",
        "city": "1145077",
        "municipio": "Huecas",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Nave industrial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1500.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1500.00",
        "surfaceTotal": "1500.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1243.20",
        "askingPriceSale": "160580.00",
        "address": "Calle Eguia  7   ",
        "postalCode": "20012",
        "city": "1120069",
        "municipio": "Donostia/San Sebastian",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.00",
        "surfaceTotal": "74.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2940.00",
        "askingPriceSale": "448000.00",
        "address": "Carretera De Moraira A Calpe  1221   ",
        "postalCode": "03725",
        "city": "1103128",
        "municipio": "Teulada",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "223.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "223.00",
        "surfaceTotal": "223.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "420.00",
        "askingPriceSale": "63000.00",
        "address": " Fco. Salzillo  s/n   ",
        "postalCode": "30166",
        "city": "1130030",
        "municipio": "Murcia",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.61",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.61",
        "surfaceTotal": "231.61",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "9e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "846.94",
        "askingPriceSale": "133728.00",
        "address": "Avenida Habaneras  83   ",
        "postalCode": "03182",
        "city": "1103133",
        "municipio": "Torrevieja",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.00",
        "surfaceTotal": "159.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "a081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1372.00",
        "askingPriceSale": "219520.00",
        "address": "Calle Onze De Setembre  26   ",
        "postalCode": "08170",
        "city": "1108136",
        "municipio": "Montornes Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.00",
        "surfaceTotal": "123.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "a281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "822.08",
        "askingPriceSale": "106870.40",
        "address": " Santa Maria Del Aguila  36   ",
        "postalCode": "04700",
        "city": "1104902",
        "municipio": "El Ejido",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "235.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.00",
        "surfaceTotal": "235.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "a481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1960.00",
        "askingPriceSale": "313600.00",
        "address": "Calle Alonso Zamora Vicente,  6   ",
        "postalCode": "28703",
        "city": "1128134",
        "municipio": "San Sebastian De Los Reyes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "29.17",
        "surfaceMezzanine": "0.00",
        "surfacepb": "102.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.63",
        "surfaceTotal": "132.05",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "a681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "914.86",
        "askingPriceSale": "140279.30",
        "address": "Plaza Cardenal Sanz Y Flores  4   ",
        "postalCode": "46701",
        "city": "1146131",
        "municipio": "Gandia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.00",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "a881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "5586.00",
        "askingPriceSale": "1565142.79",
        "address": "Calle Luchana  31   ",
        "postalCode": "28010",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "65.66",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "253.83",
        "surfaceTotal": "286.66",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "aa81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1505.35",
        "askingPriceSale": "212520.00",
        "address": "Calle Constitución  22   ",
        "postalCode": "28944",
        "city": "1128058",
        "municipio": "Fuenlabrada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "245.00",
        "surfaceTotal": "245.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "ac81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2523.78",
        "askingPriceSale": "378567.00",
        "address": "Calle Verdiales  17   ",
        "postalCode": "18014",
        "city": "1118087",
        "municipio": "Granada",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "300.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "300.45",
        "surfaceTotal": "300.45",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "ae81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1723.24",
        "askingPriceSale": "263554.20",
        "address": " Resureccion Maria De Azkue  43   ",
        "postalCode": "48902",
        "city": "1148013",
        "municipio": "Barakaldo",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.81",
        "surfaceTotal": "144.81",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "b081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "770.00",
        "askingPriceSale": "92400.00",
        "address": "Avenida Paisos Catalans  41  -  43   ",
        "postalCode": "43206",
        "city": "1143123",
        "municipio": "Reus",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.56",
        "surfaceTotal": "107.56",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "b281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "989.10",
        "askingPriceSale": "142870.00",
        "address": "Avenida Sant Iscle  23   ",
        "postalCode": "08290",
        "city": "1108266",
        "municipio": "Cerdanyola Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "b481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "862.40",
        "askingPriceSale": "117600.00",
        "address": "Calle Alcalde Jose Fernandin  6   ",
        "postalCode": "33450",
        "city": "1133747",
        "municipio": "Piedrablanca",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.00",
        "surfaceTotal": "130.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "b681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1640.80",
        "askingPriceSale": "276885.00",
        "address": "Calle San Sebastian  13-19   ",
        "postalCode": "17430",
        "city": "1117180",
        "municipio": "Santa Coloma De Farners",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "292.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "292.60",
        "surfaceTotal": "292.60",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "b881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "882.70",
        "askingPriceSale": "115430.00",
        "address": "Calle Cami De Mao,  153   ",
        "postalCode": "07760",
        "city": "1107015",
        "municipio": "Ciutadella De Menorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "97.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "97.00",
        "surfaceTotal": "97.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "ba81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "568.40",
        "askingPriceSale": "73080.00",
        "address": "Calle San Roque  22   ",
        "postalCode": "24549",
        "city": "1124038",
        "municipio": "Carracedelo",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "bc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Rincon De Ademuz  29   ",
        "postalCode": "46018",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.29",
        "surfaceTotal": "194.29",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "68845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Rincon De Ademuz  29   ",
        "postalCode": "46018",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.09",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.09",
        "surfaceTotal": "124.09",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "be81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1232.00",
        "askingPriceSale": "184800.00",
        "address": "Avenida España  3   ",
        "postalCode": "29680",
        "city": "1129051",
        "municipio": "Estepona",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.12",
        "surfaceTotal": "110.12",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "c081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "5404.06",
        "askingPriceSale": "810608.40",
        "address": " Alcalde Ramirez Bethencourt  17   ",
        "postalCode": "35004",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "398.34",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "398.34",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "405.80",
        "surfaceTotal": "684.64",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "c281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2274.30",
        "askingPriceSale": "328510.00",
        "address": "Calle Antonio Gaudi  54   ",
        "postalCode": "08830",
        "city": "1108200",
        "municipio": "Sant Boi De Llobregat",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "361.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "361.00",
        "surfaceTotal": "361.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "c481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1631.70",
        "askingPriceSale": "233100.00",
        "address": "Avenida Ollerias  37   ",
        "postalCode": "14001",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "333.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "333.12",
        "surfaceTotal": "333.12",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "c681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1393.00",
        "askingPriceSale": "208950.00",
        "address": "Calle Prior Tapia  19   ",
        "postalCode": "08222",
        "city": "1108279",
        "municipio": "Terrassa",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "199.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.00",
        "surfaceTotal": "199.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "c881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1121.40",
        "askingPriceSale": "195550.32",
        "address": " Gerald Brenan  62   ",
        "postalCode": "29004",
        "city": "1129067",
        "municipio": "Malaga",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "179.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "268.50",
        "surfaceTotal": "358.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "ca81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1386.00",
        "askingPriceSale": "207900.00",
        "address": " Candilejas  72-74   ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "208.64",
        "surfaceTotal": "208.64",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "56845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Ancha  4   ",
        "postalCode": "14700",
        "city": "1114049",
        "municipio": "Palma Del Rio",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.60",
        "surfaceTotal": "187.60",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "cc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Ancha  4   ",
        "postalCode": "14700",
        "city": "1114049",
        "municipio": "Palma Del Rio",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "98.63",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "98.63",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "49.32",
        "surfaceTotal": "98.63",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Ancha  4   ",
        "postalCode": "14700",
        "city": "1114049",
        "municipio": "Palma Del Rio",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "93.34",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "93.34",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "46.67",
        "surfaceTotal": "93.34",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "5e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Ancha  4   ",
        "postalCode": "14700",
        "city": "1114049",
        "municipio": "Palma Del Rio",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "87.75",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "87.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.88",
        "surfaceTotal": "87.75",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "60845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Ancha  4   ",
        "postalCode": "14700",
        "city": "1114049",
        "municipio": "Palma Del Rio",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "78.15",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "78.15",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "39.08",
        "surfaceTotal": "78.15",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "ce81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2492.00",
        "askingPriceSale": "352156.00",
        "address": "Avenida De Madrid  16   ",
        "postalCode": "32630",
        "city": "1132032",
        "municipio": "Xinzo De Limia",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Almacén",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "132.26",
        "surfaceBasement2": "57.03",
        "surfaceRest": "0.00",
        "surfacesr": "189.29",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.65",
        "surfaceTotal": "189.29",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "d281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "709.52",
        "askingPriceSale": "98826.00",
        "address": "Avenida Hispanidad  55   ",
        "postalCode": "03800",
        "city": "1103009",
        "municipio": "Alcoy/Alcoi",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.67",
        "surfaceTotal": "161.67",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "d481e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "address": " Canoa  9   ",
        "postalCode": "04711",
        "city": "1104902",
        "municipio": "El Ejido",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.00",
        "surfaceTotal": "84.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "d681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1494.50",
        "askingPriceSale": "256200.00",
        "address": "Avenida De La Horchata  24   ",
        "postalCode": "46120",
        "city": "1146013",
        "municipio": "Alboraya",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "295.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "295.85",
        "surfaceTotal": "295.85",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "d881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "443.52",
        "askingPriceSale": "60480.00",
        "address": "Avenida Jaume Nadal,  1bis   ",
        "postalCode": "25125",
        "city": "1125016",
        "municipio": "Alguaire",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.84",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.84",
        "surfaceTotal": "143.84",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "da81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "506.80",
        "askingPriceSale": "81088.00",
        "address": "Avenida De Lleida  61   ",
        "postalCode": "25126",
        "city": "1125021",
        "municipio": "Almenar",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.99",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.99",
        "surfaceTotal": "157.99",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "dc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "839.16",
        "askingPriceSale": "129276.00",
        "address": " Jose De Madinabeitia  14   ",
        "postalCode": "01470",
        "city": "1101002",
        "municipio": "Amurrio",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.86",
        "surfaceTotal": "161.86",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "de81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "709.80",
        "askingPriceSale": "118300.00",
        "address": " La Mar  159   ",
        "postalCode": "03590",
        "city": "1103018",
        "municipio": "Altea",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "168.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "168.94",
        "surfaceTotal": "168.94",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "e081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "715.68",
        "askingPriceSale": "107352.00",
        "address": " Francesc Camprodon  23   ",
        "postalCode": "17401",
        "city": "1117009",
        "municipio": "Arbucies",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "53.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "149.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "127.50",
        "surfaceTotal": "202.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "e281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "304.50",
        "askingPriceSale": "36750.00",
        "address": " Domenech Cardenal  36   ",
        "postalCode": "25262",
        "city": "1125041",
        "municipio": "Barbens",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "75.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "75.45",
        "surfaceTotal": "75.45",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "e481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "3181.08",
        "askingPriceSale": "636216.00",
        "address": "Calle Layret  1   ",
        "postalCode": "08911",
        "city": "1108015",
        "municipio": "Badalona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "149.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "444.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.70",
        "surfaceTotal": "593.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "e681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "828.80",
        "askingPriceSale": "124320.00",
        "address": " Mozart  17   ",
        "postalCode": "08914",
        "city": "1108015",
        "municipio": "Badalona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.10",
        "surfaceTotal": "155.10",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "e881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1694.00",
        "askingPriceSale": "321860.00",
        "address": " Rosari  45   ",
        "postalCode": "08017",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "99.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.50",
        "surfaceTotal": "209.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "ea81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5002.80",
        "askingPriceSale": "1073080.46",
        "address": "Avenida Diagonal  311   ",
        "postalCode": "08029",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "340.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "340.00",
        "surfaceTotal": "340.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "ec81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1768.87",
        "askingPriceSale": "235849.60",
        "address": " Ibargarai  26   ",
        "postalCode": "20570",
        "city": "1120074",
        "municipio": "Bergara",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.15",
        "surfaceTotal": "169.15",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "ee81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "21639.24",
        "askingPriceSale": "4183586.40",
        "address": " Gran Via Don Diego Lope De Haro  17   ",
        "postalCode": "48001",
        "city": "1148020",
        "municipio": "Bilbao",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Oficina",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "1062.44",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1062.44",
        "surfaceTotal": "1062.44",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1089.56",
        "askingPriceSale": "155652.00",
        "address": "Plaza Mayor  14   ",
        "postalCode": "42300",
        "city": "1142043",
        "municipio": "Burgo De Osma-Ciudad De Osma",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "35.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "35.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.50",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1607.26",
        "askingPriceSale": "311857.00",
        "address": " Santamañe  3   ",
        "postalCode": "48370",
        "city": "1148017",
        "municipio": "Bermeo",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "30.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.69",
        "surfaceTotal": "224.69",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "591.95",
        "askingPriceSale": "87696.00",
        "address": " Menendez Y Pelayo  2   ",
        "postalCode": "12530",
        "city": "1112032",
        "municipio": "Burriana",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "140.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "210.00",
        "surfaceTotal": "280.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f681e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "451.50",
        "askingPriceSale": "54180.00",
        "address": "Plaza De Ovando  20   ",
        "postalCode": "10950",
        "city": "1110032",
        "municipio": "Brozas",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.65",
        "surfaceTotal": "111.65",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "f881e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "361.20",
        "askingPriceSale": "42140.00",
        "address": "Paseo De La Constitucion  32   ",
        "postalCode": "23280",
        "city": "1123012",
        "municipio": "Beas De Segura",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.13",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "82.13",
        "surfaceTotal": "82.13",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "fa81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "askingPriceRent": "320.04",
        "askingPriceSale": "44450.00",
        "address": "Plaza Verge De Les Sogues  1   ",
        "postalCode": "25142",
        "city": "1125052",
        "municipio": "Bellvis",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "117.01",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.01",
        "surfaceTotal": "117.01",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "fc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "askingPriceRent": "1753.92",
        "askingPriceSale": "347760.00",
        "address": "Calle San Wenceslao de Calypso  28   ",
        "postalCode": "29649",
        "city": "1129649",
        "municipio": "Calahonda",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "108.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.00",
        "surfaceTotal": "108.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "fe81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1113.17",
        "askingPriceSale": "125231.40",
        "address": "Calle Julian Ribera  27   ",
        "postalCode": "46740",
        "city": "1146083",
        "municipio": "Carcaixent",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.78",
        "surfaceTotal": "198.78",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2447.20",
        "askingPriceSale": "322000.00",
        "address": " Llibertat  8   ",
        "postalCode": "08860",
        "city": "1108056",
        "municipio": "Castelldefels",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2518.95",
        "askingPriceSale": "352653.00",
        "address": "Calle Fuente  44905   ",
        "postalCode": "11130",
        "city": "1111015",
        "municipio": "Chiclana De La Frontera",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "359.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "359.85",
        "surfaceTotal": "359.85",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "askingPriceRent": "521.47",
        "askingPriceSale": "93221.93",
        "address": "Avenida De La Constitucion  87   ",
        "postalCode": "24800",
        "city": "1124056",
        "municipio": "Cistierna",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.00",
        "surfaceTotal": "107.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2116.80",
        "askingPriceSale": "282240.00",
        "address": " Puerto De Barcelona     ",
        "postalCode": "28821",
        "city": "1128049",
        "municipio": "Coslada",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.92",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.92",
        "surfaceTotal": "166.92",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0882e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "672.00",
        "askingPriceSale": "89600.00",
        "address": " Urbano Pineda  s/n   ",
        "postalCode": "29100",
        "city": "1129042",
        "municipio": "Coin",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.88",
        "surfaceTotal": "159.88",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1330.00",
        "askingPriceSale": "212800.00",
        "address": " Cervantes  70   ",
        "postalCode": "41100",
        "city": "1141034",
        "municipio": "Coria Del Rio",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "239.44",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "239.44",
        "surfaceTotal": "239.44",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1607.20",
        "askingPriceSale": "180924.80",
        "address": " Merlina  20   ",
        "postalCode": "41700",
        "city": "1141038",
        "municipio": "Dos Hermanas",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "0e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1114.40",
        "askingPriceSale": "222880.00",
        "address": "Avenida Campo Torres  37   ",
        "postalCode": "03700",
        "city": "1103063",
        "municipio": "Denia",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "214.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "214.30",
        "surfaceTotal": "214.30",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "833.00",
        "askingPriceSale": "119000.00",
        "address": " Charles Darwin  6   ",
        "postalCode": "03203",
        "city": "1103065",
        "municipio": "Elche/Elx",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "769.86",
        "askingPriceSale": "110544.00",
        "address": " Diagonal  29   ",
        "postalCode": "03206",
        "city": "1103065",
        "municipio": "Elche/Elx",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.24",
        "surfaceTotal": "140.24",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1601.60",
        "askingPriceSale": "246400.00",
        "address": " Cabañal  4   ",
        "city": "1146105",
        "municipio": "Cullera",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.11",
        "surfaceTotal": "180.11",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1152.90",
        "askingPriceSale": "179340.00",
        "address": "Plaza Orient  S/N   ",
        "postalCode": "07580",
        "city": "1107014",
        "municipio": "Capdepera",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "182.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.69",
        "surfaceTotal": "182.69",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5434.80",
        "askingPriceSale": "695800.00",
        "address": " Hospici  7   ",
        "postalCode": "07200",
        "city": "1107022",
        "municipio": "Felanitx",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "221.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.50",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "733.60",
        "askingPriceSale": "110040.00",
        "address": "Calle De Castela  104   ",
        "postalCode": "15578",
        "city": "1115054",
        "municipio": "Naron",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.80",
        "surfaceTotal": "115.80",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1036.35",
        "askingPriceSale": "128310.00",
        "address": "Avenida Santa Cruz  121   ",
        "postalCode": "38611",
        "city": "1138017",
        "municipio": "Granadilla De Abona",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "53.30",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "137.12",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.55",
        "surfaceTotal": "340.42",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "1e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "5368.64",
        "askingPriceSale": "601809.60",
        "address": "Avenida Jose Luis Perez Pujada  7   ",
        "postalCode": "18006",
        "city": "1118087",
        "municipio": "Granada",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Oficina",
        "smokeStractor": undefined,
        "surfacebr": "34.97",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "460.46",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "240.72",
        "surfaceTotal": "495.43",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "753130.00",
        "address": " Madrid  92   ",
        "postalCode": "28902",
        "city": "1128065",
        "municipio": "Getafe",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.30",
        "surfaceTotal": "286.30",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "ALQUILER",
        "askingPriceSale": "147700.00",
        "address": "Avenida Del Ejercito  11   ",
        "postalCode": "19004",
        "city": "1119130",
        "municipio": "Guadalajara",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.81",
        "surfaceTotal": "202.81",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "686.00",
        "askingPriceSale": "95550.00",
        "address": " Real  37   ",
        "postalCode": "04230",
        "city": "1104052",
        "municipio": "Huercal De Almeria",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.98",
        "surfaceTotal": "161.98",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1520.40",
        "askingPriceSale": "177380.00",
        "address": " Zubiarte  33   ",
        "postalCode": "31620",
        "city": "1131122",
        "municipio": "Huarte",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.54",
        "surfaceTotal": "161.54",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Larga  18   ",
        "postalCode": "11004",
        "city": "1111020",
        "municipio": "Jerez De La Frontera",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.59",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "241.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.09",
        "surfaceTotal": "344.59",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2a82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "642.60",
        "askingPriceSale": "85680.00",
        "address": " Diputacion Foral  8   ",
        "postalCode": "31580",
        "city": "1131157",
        "municipio": "Lodosa",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Nave industrial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "98.70",
        "surfaceTotal": "98.70",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1995.00",
        "askingPriceSale": "239400.00",
        "address": "Plaza Jose Ramon Aketxe  5   ",
        "postalCode": "48940",
        "city": "1148054",
        "municipio": "Leioa",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": "Sí",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "55.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.50",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "2e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1863.68",
        "askingPriceSale": "279552.00",
        "address": " Rio Duero  46   ",
        "postalCode": "28913",
        "city": "1128074",
        "municipio": "Leganes",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.40",
        "surfaceTotal": "166.40",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1246.00",
        "askingPriceSale": "168210.00",
        "address": " Benizalon     ",
        "postalCode": "04007",
        "city": "1104013",
        "municipio": "Almeria",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.00",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1209.60",
        "askingPriceSale": "161280.00",
        "address": " Granada  131   ",
        "postalCode": "04009",
        "city": "1104013",
        "municipio": "Almeria",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.10",
        "surfaceTotal": "189.10",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1037.40",
        "askingPriceSale": "141960.00",
        "address": "Avenida Cabo de Gata  141   ",
        "postalCode": "04007",
        "city": "1104013",
        "municipio": "Almeria",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.27",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.27",
        "surfaceTotal": "158.27",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "520.80",
        "askingPriceSale": "69440.00",
        "address": "Avenida Mariano Andres  182   ",
        "postalCode": "24008",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "170.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "85.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "155750.00",
        "address": " Jose Maria De Pereda  15   ",
        "postalCode": "24006",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.12",
        "surfaceTotal": "175.12",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "640.64",
        "askingPriceSale": "99008.00",
        "address": "Avenida Jose Maria Fernandez  42   ",
        "postalCode": "24006",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.00",
        "surfaceTotal": "104.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1643.46",
        "askingPriceSale": "279930.00",
        "address": "Avenida Blas Infante  s/n   ",
        "postalCode": "21440",
        "city": "1121044",
        "municipio": "Lepe",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "3e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "45360.00",
        "address": "Plaza Fonte Dos Ranchos  6   ",
        "postalCode": "27004",
        "city": "1127028",
        "municipio": "Lugo",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.97",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.97",
        "surfaceTotal": "110.97",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1309.24",
        "askingPriceSale": "206752.00",
        "address": " Quiroga  4   ",
        "postalCode": "27004",
        "city": "1127028",
        "municipio": "Lugo",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "26.67",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "198.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.00",
        "surfaceTotal": "374.67",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1659.00",
        "askingPriceSale": "185808.00",
        "address": "Avenida Onze De Setembre  33   ",
        "postalCode": "08120",
        "city": "1108105",
        "municipio": "La Llagosta",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.00",
        "surfaceTotal": "289.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " Puente  4   ",
        "postalCode": "36500",
        "city": "1136024",
        "municipio": "Lalin",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.00",
        "surfaceTotal": "189.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5565.00",
        "askingPriceSale": "890400.00",
        "address": " Juan Rejon  95   ",
        "postalCode": "35008",
        "city": "1135016",
        "municipio": "Las Palmas De Gran Canaria",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "560.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "560.00",
        "surfaceTotal": "560.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1440.60",
        "askingPriceSale": "174930.00",
        "address": "Avenida Libertad     ",
        "postalCode": "30710",
        "city": "1130902",
        "municipio": "Los Alcazares",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4a82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "1154.30",
        "askingPriceSale": "237650.00",
        "address": " Torre Arias  6   ",
        "postalCode": "28022",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "96.59",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "102.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "79.98",
        "surfaceTotal": "198.59",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2128.00",
        "askingPriceSale": "404266.34",
        "address": "Avenida De La Osa Mayor  85   ",
        "district": "2807909",
        "postalCode": "28023",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "76.00",
        "surfaceTotal": "76.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "4e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "3763.20",
        "askingPriceSale": "721280.00",
        "address": "Carretera De Canillas  140   ",
        "district": "2807916",
        "postalCode": "28043",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2153.40",
        "askingPriceSale": "329560.72",
        "address": " Santa Virgilia  21   ",
        "district": "2807916",
        "postalCode": "28033",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.94",
        "surfaceTotal": "215.94",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "askingPriceRent": "7145.60",
        "askingPriceSale": "1339800.00",
        "address": "Calle Francisco Silvela  46   ",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "347.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "356.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "460.22",
        "surfaceTotal": "703.12",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Francisco Silvela  46   ",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "308.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "5482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "5417.12",
        "askingPriceSale": "896000.00",
        "address": " Valderribas  72   ",
        "district": "2807903",
        "postalCode": "28007",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "324.25",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.13",
        "surfaceTotal": "324.25",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "2419.83",
        "askingPriceSale": "403305.00",
        "address": " Gran Via de Hortaleza  59   ",
        "district": "2807901",
        "postalCode": "28004",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.23",
        "surfaceTotal": "115.23",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2636.21",
        "askingPriceSale": "341156.20",
        "address": " Hermanos Garcia Noblejas  18-20   ",
        "district": "2807915",
        "postalCode": "28037",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.53",
        "surfaceTotal": "221.53",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "10678.50",
        "askingPriceSale": "2273099.20",
        "address": " Lopez De Hoyos  135-137   ",
        "postalCode": "28079",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "565.39",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "565.39",
        "surfaceTotal": "565.39",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1024.80",
        "askingPriceSale": "140910.00",
        "address": " Calvo Sotelo  9   ",
        "postalCode": "36900",
        "city": "1136026",
        "municipio": "Marin",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.32",
        "surfaceTotal": "193.32",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "5e82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "487.20",
        "askingPriceSale": "60900.00",
        "address": "Calle Ana De Velasco  5   ",
        "postalCode": "31340",
        "city": "1131163",
        "municipio": "Marcilla",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.00",
        "surfaceTotal": "87.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "770.00",
        "askingPriceSale": "137443.89",
        "address": " Cirilo Santos  21   ",
        "postalCode": "24240",
        "city": "1124157",
        "municipio": "Santa Maria Del Paramo",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "294000.00",
        "address": "Avenida Abenarabi  4   ",
        "postalCode": "30008",
        "city": "1130030",
        "municipio": "Murcia",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.60",
        "surfaceTotal": "112.60",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6482e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "478.04",
        "askingPriceSale": "61110.00",
        "address": " La Tercia  61   ",
        "postalCode": "13420",
        "city": "1113052",
        "municipio": "Malagon",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.88",
        "surfaceTotal": "96.88",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6682e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "askingPriceRent": "1103.26",
        "askingPriceSale": "128713.20",
        "address": " Orti Lara  4   ",
        "postalCode": "23770",
        "city": "1123059",
        "municipio": "Marmolejo",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "131.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.34",
        "surfaceTotal": "131.34",
        "timeAvailableFrom": "9/13/22 13:24"
    },
    {
        "id": "6882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceSale": "126840.00",
        "address": "Carretera Madrid Cartagena  381   ",
        "postalCode": "30500",
        "city": "1130027",
        "municipio": "Molina De Segura",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.37",
        "surfaceTotal": "151.37",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "6a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "4681.60",
        "askingPriceSale": "790020.00",
        "address": " Ricardo Soriano  52   ",
        "postalCode": "29601",
        "city": "1129069",
        "municipio": "Marbella",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "209.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "209.30",
        "surfaceTotal": "209.30",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "6c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1834.69",
        "askingPriceSale": "224239.40",
        "address": "Plaza Marcelina De Monteys  5   ",
        "city": "1108118",
        "municipio": "El Masnou",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "163.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.07",
        "surfaceTotal": "296.57",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "6e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1724.80",
        "askingPriceSale": "197120.00",
        "address": "Avenida De Enrique Mederos  20   ",
        "postalCode": "38760",
        "city": "1138024",
        "municipio": "Los Llanos De Aridane",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.71",
        "surfaceTotal": "156.71",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1265.60",
        "askingPriceSale": "189840.00",
        "address": "Urbanización El Castillo     ",
        "postalCode": "35630",
        "city": "1135003",
        "municipio": "Antigua",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.08",
        "surfaceTotal": "111.08",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7282e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceSale": "198240.00",
        "address": " Ingeniero J. De La Cierva  s/n   ",
        "postalCode": "14013",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.65",
        "surfaceTotal": "176.65",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "950.46",
        "askingPriceSale": "141036.00",
        "address": "Urbanización Aguamarina     ",
        "postalCode": "03189",
        "city": "1103099",
        "municipio": "Orihuela",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.85",
        "surfaceTotal": "170.85",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1374.24",
        "askingPriceSale": "192393.60",
        "address": " Astiigarrako Bidea  1   ",
        "postalCode": "20180",
        "city": "1120063",
        "municipio": "Oiartzun",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.32",
        "surfaceTotal": "196.32",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "967.68",
        "askingPriceSale": "107520.00",
        "address": "Avenida De Zamora  61   ",
        "postalCode": "32005",
        "city": "1132054",
        "municipio": "Ourense",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.00",
        "surfaceTotal": "203.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "952.00",
        "askingPriceSale": "202300.00",
        "address": "Carretera General  136   ",
        "postalCode": "33010",
        "city": "1133044",
        "municipio": "Oviedo",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": " La Cestilla  2   ",
        "postalCode": "34001",
        "city": "1134120",
        "municipio": "Palencia",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "61.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "361.00",
        "surfaceBasement1": "132.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "132.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "61.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "445.30",
        "surfaceTotal": "554.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "7e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "askingPriceRent": "929.60",
        "askingPriceSale": "139440.00",
        "address": "Avenida De Asegra     ",
        "postalCode": "18210",
        "city": "1118153",
        "municipio": "Peligros",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.01",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.01",
        "surfaceTotal": "166.01",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "8082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1612.80",
        "askingPriceSale": "241920.00",
        "address": " Francesç Marti I Mora     ",
        "postalCode": "07011",
        "city": "1107040",
        "municipio": "Palma De Mallorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "8282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1077.30",
        "askingPriceSale": "167580.00",
        "address": " Amilcar  8   ",
        "postalCode": "07600",
        "city": "1107040",
        "municipio": "Palma De Mallorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.55",
        "surfaceTotal": "176.55",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "8482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1141.00",
        "askingPriceSale": "125510.00",
        "address": "Plaza Miquel Dolç  1   ",
        "postalCode": "07008",
        "city": "1107040",
        "municipio": "Palma De Mallorca",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.98",
        "surfaceTotal": "144.98",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "8682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1511.09",
        "askingPriceSale": "241774.40",
        "address": " Marcelo Celayeta  72   ",
        "postalCode": "31014",
        "city": "1131201",
        "municipio": "Pamplona/Iruña",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.87",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.87",
        "surfaceTotal": "215.87",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "8882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1560.94",
        "askingPriceSale": "227046.40",
        "address": " Joan Servera Camp  20   ",
        "postalCode": "07560",
        "city": "1107560",
        "municipio": "Cala Millor",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "212.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "36.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "163.60",
        "surfaceTotal": "376.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "8a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "askingPriceRent": "630.00",
        "askingPriceSale": "88200.00",
        "address": "Carretera De Jesus  18   ",
        "postalCode": "23790",
        "city": "1123069",
        "municipio": "Porcuna",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "8e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "406.92",
        "askingPriceSale": "61038.60",
        "address": "Plaza Mayor  28   ",
        "postalCode": "09300",
        "city": "1109321",
        "municipio": "Roa",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "40.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.00",
        "surfaceTotal": "210.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9082e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "425.04",
        "askingPriceSale": "57960.00",
        "address": " Damian Parras  4   ",
        "postalCode": "23760",
        "city": "1123006",
        "municipio": "Arjona",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.46",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.46",
        "surfaceTotal": "140.46",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "914.97",
        "askingPriceSale": "123520.95",
        "address": " Teresa Pamies     ",
        "postalCode": "43204",
        "city": "1143123",
        "municipio": "Reus",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.71",
        "surfaceTotal": "130.71",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2940.00",
        "askingPriceSale": "462000.00",
        "address": "Rua Da Fonte De Santo Antonio  21   ",
        "postalCode": "15702",
        "city": "1115078",
        "municipio": "Santiago De Compostela",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "162.51",
        "surfaceMezzanine": "0.00",
        "surfacepb": "769.17",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "310.58",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "973.21",
        "surfaceTotal": "1242.26",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "563.50",
        "askingPriceSale": "67620.00",
        "address": "Avenida De Jose Quintana  2   ",
        "postalCode": "34100",
        "city": "1134157",
        "municipio": "Saldaña",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "148.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.00",
        "surfaceTotal": "148.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1470.00",
        "askingPriceSale": "205800.00",
        "address": "Calle Real  22   ",
        "postalCode": "11100",
        "city": "1111031",
        "municipio": "San Fernando",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1248.80",
        "askingPriceSale": "117075.00",
        "address": " Cardenal Mendoza  17   ",
        "postalCode": "19250",
        "city": "1119257",
        "municipio": "Siguenza",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1285.90",
        "askingPriceSale": "191716.00",
        "address": "Avenida Malecon  25   ",
        "postalCode": "15960",
        "city": "1115635",
        "municipio": "Santa Euxia De Riveira",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "266.44",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.44",
        "surfaceTotal": "266.44",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "9e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1756.30",
        "askingPriceSale": "243180.00",
        "address": " Raval  31   ",
        "postalCode": "08770",
        "city": "1108240",
        "municipio": "Sant Sadurni Danoia",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.26",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.26",
        "surfaceTotal": "193.26",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "a082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1638.00",
        "askingPriceSale": "245700.00",
        "address": " Mosen Jacinto Verdaguer,  122   ",
        "postalCode": "08620",
        "city": "1108263",
        "municipio": "Sant Vicenc Dels Horts",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "a282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "SINGULARES",
        "askingPriceRent": "2915.50",
        "askingPriceSale": "333200.00",
        "address": " Garcia De Vinuesa  10   ",
        "postalCode": "41001",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "555.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "894.40",
        "surfaceBasement1": "724.00",
        "surfaceBasement2": "716.40",
        "surfaceRest": "712.00",
        "surfacesr": "2152.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "546.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2137.15",
        "surfaceTotal": "3601.98",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "a482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1320.90",
        "askingPriceSale": "186480.00",
        "address": "Poligono Ind. Parsi     ",
        "postalCode": "41020",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "a682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "853.02",
        "askingPriceSale": "113736.00",
        "address": " Guadalajara (Alonso Mingo-Bellavista)     ",
        "postalCode": "41014",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "a882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1176.00",
        "askingPriceSale": "147000.00",
        "address": " Montsolis  1   ",
        "postalCode": "17403",
        "city": "1117164",
        "municipio": "Sant Hilari Sacalm",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "283.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "283.57",
        "surfaceTotal": "283.57",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "aa82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "981.12",
        "askingPriceSale": "147840.00",
        "address": " Bulto  20   ",
        "postalCode": "29620",
        "city": "1129901",
        "municipio": "Torremolinos",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.00",
        "surfaceTotal": "123.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ac82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "address": "Avenida De La Arboleda  s/n   ",
        "postalCode": "41940",
        "city": "1141093",
        "municipio": "Tomares",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.45",
        "surfaceTotal": "156.45",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ae82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "askingPriceRent": "567.00",
        "askingPriceSale": "75600.00",
        "address": "Plaza Del Ferial  34   ",
        "postalCode": "31420",
        "city": "1131243",
        "municipio": "Urroz",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "121.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.50",
        "surfaceTotal": "242.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "b082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1281.00",
        "askingPriceSale": "179340.00",
        "address": " Mayor  6 y 8   ",
        "postalCode": "20170",
        "city": "1120073",
        "municipio": "Usurbil",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.90",
        "surfaceTotal": "161.90",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "b282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1036.00",
        "askingPriceSale": "155400.00",
        "address": "Avenida Onze De Setembre  16   ",
        "postalCode": "08170",
        "city": "1108136",
        "municipio": "Montornes Del Valles",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.35",
        "surfaceTotal": "158.35",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "b482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1132.88",
        "askingPriceSale": "168098.00",
        "address": " Luis Espada  43   ",
        "postalCode": "32600",
        "city": "1132085",
        "municipio": "Verin",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "80.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "91.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.50",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "b682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "SINGULARES",
        "askingPriceSale": "7572908.00",
        "address": " Policarpo Sanz  23   ",
        "postalCode": "36202",
        "city": "1136057",
        "municipio": "Vigo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "295.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "859.00",
        "surfaceBasement1": "291.00",
        "surfaceBasement2": "995.00",
        "surfaceRest": "1507.00",
        "surfacesr": "2793.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "295.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2344.00",
        "surfaceTotal": "3947.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "b882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "924924.00",
        "address": " Venezuela  34   ",
        "postalCode": "36203",
        "city": "1136057",
        "municipio": "Vigo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "439.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "439.00",
        "surfaceTotal": "439.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ba82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Avenida De La Florida  47   ",
        "postalCode": "36210",
        "city": "1136057",
        "municipio": "Vigo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "bc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "273.00",
        "askingPriceSale": "38220.00",
        "address": " Plaza Mayor  18   ",
        "postalCode": "37160",
        "city": "1137364",
        "municipio": "Villarino",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "57.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "57.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "57.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "102.60",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "be82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3827.60",
        "askingPriceSale": "535864.00",
        "address": "Plaza De Galicia  7   ",
        "postalCode": "36600",
        "city": "1136060",
        "municipio": "Vilagarcia De Arousa",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "241.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.50",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "c082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1089.48",
        "askingPriceSale": "174316.80",
        "address": " Archiduque Carlos  107-109   ",
        "postalCode": "46014",
        "city": "1146250",
        "municipio": "Valencia",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.64",
        "surfaceTotal": "155.64",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "c282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "3071.25",
        "askingPriceSale": "482108.87",
        "address": " Tierra De Medina  5   ",
        "postalCode": "47008",
        "city": "1147186",
        "municipio": "Valladolid",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Terciario",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "324.90",
        "surfaceTotal": "324.90",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "c482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1020.60",
        "askingPriceSale": "147336.00",
        "address": " Santa Lucia  19   ",
        "postalCode": "47004",
        "city": "1147186",
        "municipio": "Valladolid",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "323.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "323.80",
        "surfaceTotal": "323.80",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "c682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "204.40",
        "askingPriceSale": "28616.00",
        "address": " Gran Via  SN   ",
        "postalCode": "25690",
        "city": "1125254",
        "municipio": "Vilanova De La Barca",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "72.92",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "72.92",
        "surfaceTotal": "72.92",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "c882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1577.80",
        "askingPriceSale": "315560.00",
        "address": "Avenida Do Xubia  15   ",
        "postalCode": "15570",
        "city": "1115054",
        "municipio": "Naron",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "130.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "228.67",
        "surfaceTotal": "293.72",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ca82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "767.20",
        "askingPriceSale": "105490.00",
        "address": "Carretera De Logroño  48-50-52   ",
        "postalCode": "50620",
        "city": "1150297",
        "municipio": "Zaragoza",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "150.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "75.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "cc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "askingPriceRent": "1114.74",
        "askingPriceSale": "153276.20",
        "address": " Del Mar     ",
        "postalCode": "04620",
        "city": "1104100",
        "municipio": "Vera",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "188.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.00",
        "surfaceTotal": "253.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ce82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "5390.00",
        "askingPriceSale": "770000.00",
        "address": " Isabel La Catolica,  2   ",
        "postalCode": "18009",
        "city": "1118087",
        "municipio": "Granada",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "87.65",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "73.16",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "288.19",
        "surfaceTotal": "386.12",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "d082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "2368.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2368.00",
        "surfaceTotal": "2368.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "6c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "24.72",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.42",
        "surfaceTotal": "24.72",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "6e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "29.02",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "8.71",
        "surfaceTotal": "29.02",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "70845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "28.31",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "8.49",
        "surfaceTotal": "28.31",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "72845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "26.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.88",
        "surfaceTotal": "26.25",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "74845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "20.88",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "6.26",
        "surfaceTotal": "20.88",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "76845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "23.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.07",
        "surfaceTotal": "23.57",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "78845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "askingPriceRent": "854.28",
        "askingPriceSale": "129724.00",
        "address": "Calle Antonio Gaudí  6   ",
        "postalCode": "14005",
        "city": "1114021",
        "municipio": "Cordoba",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "680.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "680.00",
        "surfaceTotal": "680.00",
        "timeAvailableFrom": "9/13/22 14:50"
    },
    {
        "id": "d282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "854.28",
        "askingPriceSale": "129724.00",
        "address": " Feria  3   ",
        "postalCode": "49004",
        "city": "1149275",
        "municipio": "Zamora",
        "province": "49",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "226.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.00",
        "surfaceTotal": "226.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "d482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Carretera de Vigo  25   ",
        "postalCode": "321450",
        "city": "1132025",
        "municipio": "Cenlle",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "114.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.54",
        "surfaceTotal": "114.54",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "d682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Ribeira Ribeira de Maio  2   ",
        "postalCode": "15240",
        "city": "1115053",
        "municipio": "Muros",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.00",
        "surfaceTotal": "96.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "d882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4833.29",
        "askingPriceSale": "790902.00",
        "address": " Independencia  6   ",
        "postalCode": "24001",
        "city": "1124089",
        "municipio": "Leon",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "287.79",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "411.97",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "292.32",
        "surfaceTotal": "699.76",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "da82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1789.20",
        "askingPriceSale": "268380.00",
        "address": "Calle Pages Del Corro  79   ",
        "postalCode": "41010",
        "city": "1141091",
        "municipio": "Sevilla",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "201.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.40",
        "surfaceTotal": "201.40",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "dc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceSale": "954800.00",
        "address": "Calle Fuentecillas  8   ",
        "postalCode": "40410",
        "city": "1140076",
        "municipio": "El Espinar",
        "province": "40",
        "CCAA": "59",
        "country": "ES",
        "use": "Centro Formación",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "548.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "274.00",
        "surfaceTotal": "548.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "e282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1334.11",
        "askingPriceSale": "251851.60",
        "address": "Paseo De Valldaura  212   ",
        "postalCode": "08042",
        "city": "1108019",
        "municipio": "Barcelona",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "81.77",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "40.89",
        "surfaceTotal": "81.77",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "e482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2744.00",
        "askingPriceSale": "372400.00",
        "address": " Real  31   ",
        "postalCode": "28400",
        "city": "1128047",
        "municipio": "Collado Villalba",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "103.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.36",
        "surfaceTotal": "275.02",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "e682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1676.50",
        "askingPriceSale": "234710.00",
        "address": "Calle Gándara  8   ",
        "postalCode": "36619",
        "city": "1136057",
        "municipio": "Vigo",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Nave industrial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.53",
        "surfaceTotal": "286.53",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "e882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "4697.28",
        "askingPriceSale": "587160.00",
        "address": "Calle Carrasco I Formiguera     ",
        "postalCode": "08302",
        "city": "1108121",
        "municipio": "Mataro",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "2796.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2796.00",
        "surfaceTotal": "2796.00",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ea82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "1724.80",
        "askingPriceSale": "190344.00",
        "address": " Residencial Al- Baida Pueblo Arabe     ",
        "postalCode": "04740",
        "city": "1104079",
        "municipio": "Roquetas De Mar",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.25",
        "surfaceTotal": "224.25",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ec82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "991.20",
        "askingPriceSale": "161070.00",
        "address": " Barcelona  10  12   ",
        "postalCode": "15100",
        "city": "1115019",
        "municipio": "Carballo",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.35",
        "surfaceTotal": "173.35",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "ee82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "2275.00",
        "askingPriceSale": "350000.00",
        "address": " Ramon y Cajal  2   ",
        "postalCode": "36600",
        "city": "1136060",
        "municipio": "Vilagarcia De Arousa",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "239.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "239.82",
        "surfaceTotal": "239.82",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "f082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "2372.58",
        "askingPriceSale": "342706.00",
        "address": "Plaza Peregrina  50   ",
        "postalCode": "36001",
        "city": "1136038",
        "municipio": "Pontevedra",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "91.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "66.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.85",
        "surfaceTotal": "285.90",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "f282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "askingPriceRent": "4081.00",
        "askingPriceSale": "489300.00",
        "address": " Maria De Zayas Plaza  11   ",
        "postalCode": "09001",
        "city": "1109059",
        "municipio": "Burgos",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "379.13",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.57",
        "surfaceTotal": "379.13",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "f482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "917.70",
        "askingPriceSale": "135660.00",
        "address": "Avenida Villajoyosa     ",
        "postalCode": "03502",
        "city": "1103031",
        "municipio": "Benidorm",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "57.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "57.14",
        "surfaceTotal": "57.14",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "f682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "askingPriceRent": "1329.44",
        "askingPriceSale": "265888.00",
        "address": " Partida La Cala     ",
        "postalCode": "03502",
        "city": "1103031",
        "municipio": "Benidorm",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.96",
        "surfaceTotal": "94.96",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "f882e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "askingPriceRent": "1433.15",
        "askingPriceSale": "266156.80",
        "address": "Avenida España  15   ",
        "postalCode": "28100",
        "city": "1128006",
        "municipio": "Alcobendas",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": undefined,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.24",
        "surfaceTotal": "146.24",
        "timeAvailableFrom": "9/13/22 13:25"
    },
    {
        "id": "fa82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "address": "Calle Nuñez De Balboa  56   ",
        "district": "2807904",
        "postalCode": "28001",
        "city": "1128079",
        "municipio": "Madrid",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Oficina",
        "smokeStractor": undefined,
        "surfacebr": "272.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "243.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "272.80",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "325.66",
        "surfaceTotal": "516.62",
        "timeAvailableFrom": "9/13/22 13:25"
    }
]